unit GiftAidClaimForm;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  JobBaseForm,
  WEBLib.ExtCtrls,
  Data.DB,
  WEBLib.DB,
  XData.Web.JsonDataset,
  XData.Web.Dataset,
  WEBLib.WebCtrls,
  Vcl.Controls,
  Vcl.StdCtrls,
  WEBLib.Grids,
  WEBLib.DBCtrls,
  WEBLib.StdCtrls,
  Vcl.Mask,
  WEBLib.Mask,
  WEBLib.CDS, DB,
  GA.Return.Types, Vcl.Imaging.GIFImg;


type
  TClaimJobToPlace = (cjpPrepareClaim, cjpSubmitPreparedClaim);

  TGiftAidClaimJob = class(TJobBase)
    AgreeCheckBox: TCheckBox;
    AuthorisedOfficial: TLookupComboBox;
    AuthOfficials: TXDataWebDataSet;
    AuthOfficialsId: TIntegerField;
    AuthOfficialsFirstName: TStringField;
    AuthOfficialsLastName: TStringField;
    ConfigDataset: TXDataWebDataSet;
    ConfigDatasetId: TIntegerField;
    ConfigDatasetHMRCOfficial: TIntegerField;
    ConfigDatasetCharityRef: TStringField;
    ConfigDatasetCharityType: TStringField;
    ConfigDatasetGatewayId: TStringField;
    ConfigDatasetGatewayPassword: TStringField;
    ConfigDatasetRegulator: TStringField;
    ConfigDatasetRegulatorNumber: TStringField;
    ConfigDatasetEndOfYear: TStringField;
    ConfigDatasetOrganisationType: TStringField;
    ConfigDatasetOrganisationName: TStringField;
    ConfigDatasetSubmissionMethod: TStringField;
    ErrorHandling: TLookupComboBox;
    JobsPlacedDateAdded: TDateTimeField;
    JobsPlacedAddedBy: TIntegerField;
    JobsPlacedLastUpdatedBy: TIntegerField;
    JobsPlacedJobCategory: TStringField;
    JobsPlacedLastPolled: TDateTimeField;
    JobsPlacedPollInterval: TLargeintField;
    JobsPlacedPollCount: TIntegerField;
    HMRCPassword: TEdit;
    LoginPassword: TEdit;
    GAUsers: TClientDataSet;
    UserClaimRef: TEdit;
    InitialCheck: TTimer;
    DisplayClaimDeclaration: TTimer;
    ClaimDeclaration: TXDataWebDataSet;
    ClaimDeclarationId: TIntegerField;
    ClaimDeclarationDateAdded: TDateTimeField;
    ClaimDeclarationAddedBy: TIntegerField;
    ClaimDeclarationLastUpdatedBy: TIntegerField;
    ClaimDeclarationLastUpdated: TDateTimeField;
    ClaimDeclarationClaimId: TIntegerField;
    ClaimDeclarationDeclarationVersion: TIntegerField;
    ClaimDeclarationDeclarationHash: TStringField;
    ClaimDeclarationDeclarationIssueDate: TDateTimeField;
    ClaimDeclarationDeclarationExpiryDate: TDateTimeField;
    ClaimDeclarationDeclarationSignedDate: TDateTimeField;
    ClaimDeclarationDeclarationSignedByUser: TIntegerField;
    ClaimDeclarationDeclarationSignedByName: TStringField;
    ClaimDeclarationDeclarationSigningChannel: TStringField;
    ClaimDeclarationDeclarationStatus: TStringField;
    ClaimDeclarationDeclarationRevokedDate: TDateTimeField;
    ClaimDeclarationSignedDeclarationText: TStringField;
    ConfirmSignDeclarationButton: TButton;
    CancelSignDeclarationButton: TButton;
    PrepareClaimDataXXX: TTableControl;
    ConfirmClaimCheckBox: TCheckBox;
    OldestDateParameter: TDateTimePicker;
    NewestDateParameter: TDateTimePicker;
    ImportFiles: TLookupComboBox;
    PrepareWaitMessage: TWaitMessage;
    CancelPrepareClaimButton: TButton;
    PrepareClaimButton: TButton;
    DownloadDonationsButton: TButton;
    ViewAdjustmentsButton: TButton;
    PrepareClaimTimer: TTimer;
    DeclarationTextMemo: TMemo;
    PrepareClaimData: TTableControl;
    AcknowledgePartialClaim: TCheckBox;
    MaximumGiftAidAmountForClaim: TEdit;
    procedure WebFormCreate(Sender: TObject);
    procedure AgreeCheckBoxClick(Sender: TObject);
    procedure AcknowledgePartialClaimClick(Sender: TObject);
    procedure AuthOfficialsAfterOpen(Dataset: TDataSet);
    [async]
    procedure AuthorisedOfficialChange(Sender: TObject); async;
    [async]
    procedure ConfirmSignDeclarationButtonClick(Sender: TObject); async;
    procedure CancelSignDeclarationButtonClick(Sender: TObject);
    procedure LoginPasswordKeyPress(Sender: TObject; var Key: Char);
    procedure ConfigDatasetAfterOpen(Dataset: TDataSet);
    procedure HMRCPasswordChange(Sender: TObject);
    procedure HMRCPasswordExit(Sender: TObject);
    procedure UserClaimRefExit(Sender: TObject);
    procedure InitialCheckTimer(Sender: TObject);
    procedure PlaceJobButtonClick(Sender: TObject);
    [async]
    procedure ConfirmClaimCheckBoxClick(Sender: TObject); async;
    [async]
    procedure PlaceSubmissionJobButtonClick(Sender: TObject); async;
    //procedure WebFormShow(Sender: TObject);
    procedure UserClaimRefChange(Sender: TObject);
    [async]
    procedure CancelPrepareClaimButtonClick(Sender: TObject); async;
    procedure DisplayClaimDeclarationTimer(Sender: TObject);
    procedure ClaimDeclarationAfterPost(DataSet: TDataSet);
    [async]
    procedure PrepareClaimButtonClick(Sender: TObject); async;
    [async]
    procedure DownloadDonationsButtonClick(Sender: TObject); async;
    [async]
    procedure ViewAdjustmentsButtonClick(Sender: TObject); async;
    procedure PrepareClaimTimerTimer(Sender: TObject);
    [async]
    procedure ParameterChange(Sender: TObject); async;
    procedure MaximumGiftAidAmountForClaimChange(Sender: TObject);
    procedure MaximumGiftAidAmountForClaimExit(Sender: TObject);
  private
    { Private declarations }
//    FUnclaimedAmount: Currency;
//    FUnclaimedCount: Integer;
    FRememberPasswordEnabled: boolean;
//    FSubmissionJob: boolean;
    FJobToPlace: TClaimJobToPlace;
    FPrepareDataReviewed: Boolean;
    FPrepareJobCreated: Boolean;
    FClaimId: integer;
    FGatewayId: string;
    FDeclarationVersionText: string;
    FDeclarationHash: string;
    FDeclarationSigned: Boolean;
    FSignerEligible: Boolean;
    FSignerUserId: Integer;
    FSignedByUserId: Integer;
    FUpdatingAuthorisedOfficials: Boolean;
    FPartialClaimLimitExceeded: Boolean;
    FPartialClaimAcknowledged: Boolean;
    FNothingToClaim: Boolean;
    FResumingClaim: Boolean;
    FHasClaimablePrepare: Boolean;
    FSignedDeclarationText: string;
    FDeclarationSignedAt: TDateTime;
    FManagedAgentSubmissionType: string;

    function AgentSessionActive: Boolean;
    function AgentSigningAsAgent: Boolean;
    function AgentSigningAsCharity: Boolean;
    function PasswordVerifierUserId: Integer;
    function ClaimHmrcOfficialUserId: Integer;
    procedure SyncAgentSigningUi;
    [async]
    procedure LoadManagedAgentSubmissionType; async;

    [async]
    procedure LoadAuthOfficials; async;
    [async]
    procedure GetUnclaimedValues; async;
    [async]
    procedure SearchForAuthOfficials; async;
    [async]
    procedure CheckForRememberPassword; async;

    procedure PopulateDeclarationText;
    function HasDeclarationTextReady: Boolean;
    procedure SyncSelectedAuthorisedOfficial;
    function SelectedAuthorisedOfficialName: string;
    function CharityOfficialDisplayName: string;
    function HasSubmissionIdForSigning: Boolean;
    function ClaimFiguresConfirmed: Boolean;
    function PromptedLoginPassword: string;
    [async]
    procedure InvalidateDeclarationForClaimDataChange(const AReason: string); async;
    [async]
    function VerifySignerLoginPassword(const APassword: string): Boolean; async;
    procedure ShowSignPasswordModal(const AShow: Boolean);
    [async]
    procedure GetGatewayId; async;
    [async]
    procedure GetDeclarationVersionText; async;
    [async]
    procedure LoadAndShowDeclaration; async;
    procedure AddClaimDeclarationTextToMeno(AText: string);
    [async]
    procedure SignActiveClaimDeclaration; async;
    function HasValidSignedDeclaration: Boolean;
    function ValidateSignerIdentity(out AMessage: string): Boolean;
    procedure UpdateDeclarationActionState;
    procedure LockDeclarationControls(const ALocked: Boolean);
    [async]
    procedure HashClaimDeclaration; async;
    function GetUserName: string;

    [async]
    procedure GetClaimParameters; async;

    procedure UpdateClaimFormForSubmission;
    procedure SyncFiguresActionButtons;
    procedure SetClaimSelectionControlsEnabled(AEnabled: Boolean);
    procedure SetClaimParameters(AClaimParameters: TClaimParameters);
    procedure PopulatePrepareGrid(APrepareClaimData: TPrepareClaimData);
    procedure UpdatePartialClaimLimitWarning(APrepareClaimData: TPrepareClaimData);
    procedure ClearPartialClaimLimitWarning;
    procedure UpdateEmptyPrepareClaimMessage(APrepareClaimData: TPrepareClaimData);
    procedure ClearEmptyPrepareClaimMessage;
    function PartialClaimReadyToPrepare: Boolean;
    function HasClaimablePrepareResult(APrepareClaimData: TPrepareClaimData): Boolean;
    procedure SyncPlaceJobButtonVisibility;
    procedure SetPlaceJobPrepareVisible(AVisible: Boolean);
    procedure SetClaimPreparedAttribute(APrepared: Boolean);
    procedure AddPrepareDataColumn(var ACol: integer; AHeader: string; AValue: Currency);
    [async]
    procedure CancelPrepareClaim; async;
    [async]
    procedure ResetPrepareClaim; async;
    procedure ClearPreparePreview;
    procedure ResetClaim;
    procedure ShowClaimWizardStep(AStep: Integer);
    procedure ShowResumeClaimBanner(const AClaimRef: string; ADeclarationSigned: Boolean);
    procedure HideResumeClaimBanner;
    procedure SyncSubmissionIdDisplay;
    [async]
    procedure PlacePrepareClaimJob(Sender: TObject); async;
    [async]
    procedure PlaceSubmitPreparedClaimJob(Sender: TObject); async;

    [async]
    procedure GetPrepareClaimPreviewData; async;
    [async]
    procedure GetPrepareClaimData; async;
    [async]
    procedure LoadMaximumGiftAidAmountForClaim; async;
    function MaximumGiftAidAmountForClaimValue: Double;
    [async]
    procedure EnsureXDataConnected; async;
    [async]
    procedure InitializeClaimFormData; async;

  protected
    procedure JobParams(AJobParams: JS.TJSObject); override;
    function MinimumProcessLevel: string; override;
    function DefaultRunLevel: string; override;
    function JobDescription: string; override;
    function JobDisplayName: string; override;
    function JobClass: string; override;
    function CanPlaceJob: Boolean; override;
    procedure AfterPlaceJob; override;
//    function CheckForMerging;

  public
    { Resume a WaitingAuth prepared claim (RetrievePreparedClaim). }
    [async]
    procedure ResumeInProgressClaim; async;
  protected procedure LoadDFMValues; override; end;


implementation

{$R *.dfm}

uses
  MainDataModule,
  XData.Web.Client,
  SMX.Web.Document.Utils,
  SMX.Web.Utils,
  jsdelphisystem,
  MainForm,
  XData.Dataset.Utils,
  ClaimAdjustmentsPopup;


procedure TGiftAidClaimJob.WebFormCreate(Sender: TObject);
begin
  inherited;
  FJobToPlace := cjpPrepareClaim;
  FPrepareDataReviewed := False;
  FPrepareJobCreated := False;
  PrepareClaimButton.Caption := 'Evaluate Claim';
  // JobBase.SetButtonValues overwrites this to "Place Job"; restore prepare label.
  PlaceJobButton.Caption := 'Prepare Claim';
  PlaceJobButton.Enabled := False;
  SetPlaceJobPrepareVisible(False);
  SetClaimPreparedAttribute(False);
  SyncFiguresActionButtons;
  SyncPlaceJobButtonVisibility;
  AgreeCheckBox.Enabled := False;
  AgreeCheckBox.Checked := False;
  FRememberPasswordEnabled := False;
  FDeclarationSigned := False;
  FSignedDeclarationText := '';
  FDeclarationSignedAt := 0;
  FSignerEligible := False;
  FSignerUserId := 0;
  OutputOption.Visible := False;
  JobRunType.Visible := False;
  HMRCPassword.Text := '';

  GetUnclaimedValues;

  ErrorHandling.LookupValues.AddPair('OmitRecord', 'Omit Record');
  ErrorHandling.LookupValues.AddPair('CancelSubmission', 'Cancel Submission');
  ErrorHandling.ItemIndex := 0;

  HMRCPassword.Text := '';
  FPartialClaimLimitExceeded := False;
  FPartialClaimAcknowledged := False;
  FNothingToClaim := False;
  FResumingClaim := False;
  FHasClaimablePrepare := False;
  FSignedByUserId := 0;
  FManagedAgentSubmissionType := '';
  FUpdatingAuthorisedOfficials := False;
  AuthorisedOfficial.LookupValues.Clear;
  AuthorisedOfficial.ItemIndex := -1;
  AuthorisedOfficial.Enabled := True;
  InitialCheck.Enabled := True;
//  ResetClaim;

  DeclarationTextMemo.ReadOnly := True;
  DeclarationTextMemo.Lines.Text := 'Loading declaration…';
  { One serialized open + load path — parallel OpenAsync races free the XData model. }
  InitializeClaimFormData;
end;

procedure TGiftAidClaimJob.EnsureXDataConnected;
begin
  await(MainData.EnsureConnectionOpen);
end;

procedure TGiftAidClaimJob.InitializeClaimFormData;
begin
  await(EnsureXDataConnected);
  await(LoadManagedAgentSubmissionType);
  await(SearchForAuthOfficials);
  await(CheckForRememberPassword);
  await(GetClaimParameters);
  await(LoadMaximumGiftAidAmountForClaim);
  await(LoadAndShowDeclaration);
  UpdateDeclarationActionState;
end;

procedure TGiftAidClaimJob.AgreeCheckBoxClick(Sender: TObject);
begin
  UpdateDeclarationActionState;
  CanPlaceJob;
end;

procedure TGiftAidClaimJob.AcknowledgePartialClaimClick(Sender: TObject);
begin
  FPartialClaimAcknowledged := AcknowledgePartialClaim.Checked;
  CanPlaceJob;
  SyncPlaceJobButtonVisibility;
end;

procedure TGiftAidClaimJob.AuthOfficialsAfterOpen(Dataset: TDataSet);
begin
  PlaceJobButton.Enabled := False;
  SyncPlaceJobButtonVisibility;
  LoadAuthOfficials;
end;

{ TGiftAidClaimJob }

procedure TGiftAidClaimJob.CancelPrepareClaimButtonClick(Sender: TObject);
begin
  inherited;
  CancelPrepareClaimButton.Enabled := False;
  await(CancelPrepareClaim);
end;

procedure TGiftAidClaimJob.ShowClaimWizardStep(AStep: Integer);
begin
  {$IFDEF PAS2JS}
  asm
    var nav = document.getElementById('claimWizardNav' + AStep);
    if (nav && window.smxShowGiftAidClaimStep) {
      window.smxShowGiftAidClaimStep(nav, AStep);
    }
  end;
  {$ENDIF}
end;

procedure TGiftAidClaimJob.SyncSubmissionIdDisplay;
var
  lClaimRef: string;
begin
  lClaimRef := Trim(UserClaimRef.Text);
  if lClaimRef = '' then
    lClaimRef := '—';
  {$IFDEF PAS2JS}
  asm
    var el = document.getElementById('UserClaimRefDisplay');
    if (el) {
      el.textContent = lClaimRef;
    }
  end;
  {$ENDIF}
end;

procedure TGiftAidClaimJob.ShowResumeClaimBanner(const AClaimRef: string; ADeclarationSigned: Boolean);
var
  lText: string;
begin
  lText := 'Continuing prepared claim ' + AClaimRef +
    ' — review the actual figures, then Continue to Sign and Submit.';

  {$IFDEF PAS2JS}
  asm
    var banner = document.getElementById('ResumeClaimBanner');
    if (banner) {
      banner.textContent = lText;
      banner.style.display = 'block';
    }
  end;
  {$ENDIF}
end;

procedure TGiftAidClaimJob.HideResumeClaimBanner;
begin
  {$IFDEF PAS2JS}
  asm
    var banner = document.getElementById('ResumeClaimBanner');
    if (banner) {
      banner.textContent = '';
      banner.style.display = 'none';
    }
  end;
  {$ENDIF}
end;

procedure TGiftAidClaimJob.InvalidateDeclarationForClaimDataChange(const AReason: string);
begin
  if not FDeclarationSigned then
    Exit;

  { Session sign only until submit — clear local state so Sign and Submit cannot proceed. }
  FDeclarationSigned := False;
  FSignedByUserId := 0;
  FSignedDeclarationText := '';
  FDeclarationSignedAt := 0;
  AgreeCheckBox.Checked := False;
  LockDeclarationControls(False);
  UpdateDeclarationActionState;
  CanPlaceJob;

  if AReason <> '' then
    SetJobMessage(AReason);
end;

procedure TGiftAidClaimJob.ResumeInProgressClaim;
var
  lRetval: TXDataClientResponse;
  lRetrievePreparedClaim: TRetrievePreparedClaim;
  lPrepareClaimData: TPrepareClaimData;
  lResponse: TJSObject;
  lOldestDate, lNewestDate: TDate;
begin
  try
    await(EnsureXDataConnected);
    lRetval := await(TXDataClientResponse,
      MainData.WebClient.RawInvokeAsync('IGiftAiderService.RetrievePreparedClaim', []));
  except
    on E: Exception do
    begin
      SetJobMessage('Could not load the prepared claim (' + E.Message +
        '). Evaluate, confirm, Prepare Claim, then Sign and Submit.');
      Exit;
    end;
  end;

  lResponse := lRetval.ResultAsObject;
  if not Assigned(lResponse) then
    Exit;

  lRetrievePreparedClaim := TRetrievePreparedClaim.Create;
  try
    lRetrievePreparedClaim.Assign(lResponse);
    if (not lRetrievePreparedClaim.Exists) or (lRetrievePreparedClaim.ClaimId <= 0) then
      Exit;

    FResumingClaim := True;
    FPrepareDataReviewed := True;
    FPrepareJobCreated := True;
    FJobToPlace := cjpSubmitPreparedClaim;
    FClaimId := lRetrievePreparedClaim.ClaimId;
    JobId := lRetrievePreparedClaim.PrepareJobId;

    lOldestDate := StrToDate(lRetrievePreparedClaim.OldestDate);
    lNewestDate := StrToDate(lRetrievePreparedClaim.NewestDate);
    OldestDateParameter.Date := lOldestDate;
    NewestDateParameter.Date := lNewestDate;
    ImportFiles.Value := lRetrievePreparedClaim.ImportId;

    if lRetrievePreparedClaim.ClaimRef <> '' then
    begin
      UserClaimRef.Text := UpperCase(lRetrievePreparedClaim.ClaimRef);
      UserClaimRef.Enabled := False;
      TDocUtils.setControlValidity(UserClaimRef.ElementID, TValidityState.vsValid);
    end;

    ConfirmClaimCheckBox.Checked := True;
    ConfirmClaimCheckBox.Enabled := False;

    lPrepareClaimData := TPrepareClaimData.Create;
    try
      lPrepareClaimData.Complete := True;
      lPrepareClaimData.ClaimId := lRetrievePreparedClaim.ClaimId;
      lPrepareClaimData.DonationCount := lRetrievePreparedClaim.DonationCount;
      lPrepareClaimData.Amount := lRetrievePreparedClaim.Amount;
      lPrepareClaimData.GiftAid := lRetrievePreparedClaim.GiftAid;
      lPrepareClaimData.GASDS := lRetrievePreparedClaim.GASDS;
      lPrepareClaimData.AggregatedDonations := lRetrievePreparedClaim.AggregatedDonations;
      lPrepareClaimData.OtherIncome := lRetrievePreparedClaim.OtherIncome;
      lPrepareClaimData.GASDSAdjustments := lRetrievePreparedClaim.GASDSAdjustments;
      lPrepareClaimData.Adjustments := lRetrievePreparedClaim.Adjustments;
      lPrepareClaimData.CommunityBuildings := lRetrievePreparedClaim.CommunityBuildings;
      lPrepareClaimData.LimitExceeded := False;
      lPrepareClaimData.NothingFitsLimit := False;
      lPrepareClaimData.MaxClaimCount := 0;
      lPrepareClaimData.MaxClaimAmount := -1;
      lPrepareClaimData.IncludedDonationCount := lRetrievePreparedClaim.DonationCount;
      lPrepareClaimData.IncludedAmount := lRetrievePreparedClaim.Amount;
      lPrepareClaimData.IncludedGiftAid := lRetrievePreparedClaim.GiftAid;
      lPrepareClaimData.RemainingDonationCount := 0;
      lPrepareClaimData.RemainingAmount := 0;
      lPrepareClaimData.RemainingGiftAid := 0;
      PopulatePrepareGrid(lPrepareClaimData);
    finally
      lPrepareClaimData.Free;
    end;

    { Signing is session-only until Sign and Submit persists CLAIM_DECLARATION. }
    FDeclarationSigned := False;
    FSignedByUserId := 0;
    FSignedDeclarationText := '';
    FDeclarationSignedAt := 0;
    AgreeCheckBox.Checked := False;
    AgreeCheckBox.Enabled := True;
    LockDeclarationControls(False);
    ClearJobMessage;
    SetJobMessage(
      'Continuing prepared claim ' + UserClaimRef.Text +
      '. Review the actual figures, then Continue to Sign and Submit.');

    ShowResumeClaimBanner(UserClaimRef.Text, False);
    SyncSubmissionIdDisplay;
    SetClaimPreparedAttribute(True);
    SetPlaceJobPrepareVisible(False);
    UpdateClaimFormForSubmission;
    { Land on prepared figures (step 2); declaration is step 3 via Continue. }
    ShowClaimWizardStep(2);
    UpdateDeclarationActionState;
    CanPlaceJob;
  finally
    lRetrievePreparedClaim.Free;
  end;
end;

function TGiftAidClaimJob.CanPlaceJob: Boolean;
var
  sPassword: string;
  lIdentityMessage: string;

begin
  UpdateDeclarationActionState;

  if not FPrepareJobCreated then
  begin
    { JobId set while prepare is still running — do not place again. }
    if JobId <> 0 then
    begin
      Result := False;
      PlaceJobButton.Caption := 'Prepare Claim';
      PlaceJobButton.Enabled := False;
      SetPlaceJobPrepareVisible(False);
      SetClaimPreparedAttribute(False);
      SyncPlaceJobButtonVisibility;
      Exit;
    end;

    Result := FPrepareDataReviewed and ClaimFiguresConfirmed and HasSubmissionIdForSigning and
      PartialClaimReadyToPrepare;
    PlaceJobButton.Caption := 'Prepare Claim';
    PlaceJobButton.Enabled := Result;
    if PlaceJobButton.ElementID <> '' then
    begin
      TDocUtils.writeHTML(PlaceJobButton.ElementID, 'Prepare Claim');
      PlaceJobButton.ElementHandle.setAttribute('aria-label', 'Prepare Claim');
      if Result then
        PlaceJobButton.ElementHandle.removeAttribute('disabled')
      else
        PlaceJobButton.ElementHandle.setAttribute('disabled', 'disabled');
    end;
    if HasSubmissionIdForSigning then
      TDocUtils.setControlValidity(UserClaimRef.ElementID, TValidityState.vsValid)
    else
      TDocUtils.setControlValidity(UserClaimRef.ElementID, TValidityState.vsInvalid);
    { Visible only when ready to prepare — includes Submission ID. }
    SetPlaceJobPrepareVisible(Result);
    SetClaimPreparedAttribute(False);
    SyncPlaceJobButtonVisibility;
    Exit;
  end;

  Result := True;
  PlaceJobButton.Caption := 'Sign and Submit';
  if PlaceJobButton.ElementID <> '' then
  begin
    TDocUtils.writeHTML(PlaceJobButton.ElementID, 'Sign and Submit');
    PlaceJobButton.ElementHandle.setAttribute('aria-label', 'Sign and Submit');
  end;
  SetPlaceJobPrepareVisible(False);
  { Only mark prepared once the poll has a ClaimId — keeps step 3 gated. }
  SetClaimPreparedAttribute(FClaimId > 0);

  if FSignerEligible and (FSignerUserId > 0) then
    TDocUtils.setControlValidity(AuthorisedOfficial.ElementID, TValidityState.vsValid)
  else
  begin
    TDocUtils.setControlValidity(AuthorisedOfficial.ElementID, TValidityState.vsInvalid);
    Result := Result and (not AuthorisedOfficial.Visible);
  end;

  if (OutputOption.ItemIndex > -1) then
    TDocUtils.setControlValidity(OutputOption.ElementID, TValidityState.vsValid)
  else
  begin
    TDocUtils.setControlValidity(OutputOption.ElementID, TValidityState.vsInvalid);
    Result := Result and (not OutputOption.Visible);
  end;

  if HasSubmissionIdForSigning then
    TDocUtils.setControlValidity(UserClaimRef.ElementID, TValidityState.vsValid)
  else
  begin
    TDocUtils.setControlValidity(UserClaimRef.ElementID, TValidityState.vsInvalid);
    Result := Result and (not UserClaimRef.Visible);
  end;

  if FRememberPasswordEnabled then
    TDocUtils.setControlValidity(HMRCPassword.ElementID, TValidityState.vSNone)
  else if (HMRCPassword.Text <> '') or FRememberPasswordEnabled then
    TDocUtils.setControlValidity(HMRCPassword.ElementID, TValidityState.vsValid)
  else
  begin
    TDocUtils.setControlValidity(HMRCPassword.ElementID, TValidityState.vsInvalid);
    Result := Result and (not HMRCPassword.Visible);
  end;

  { Sign and Submit opens the login-password prompt; the job is placed after a correct password. }
  Result := Result and (FJobToPlace = cjpSubmitPreparedClaim) and ClaimFiguresConfirmed and
    FSignerEligible and AgreeCheckBox.Checked and HasDeclarationTextReady and
    HasSubmissionIdForSigning;

  if Result then
  begin
    sPassword := HMRCPassword.Text;

    if (sPassword.Trim.IsEmpty) and (not FRememberPasswordEnabled) then
    begin
      TDocUtils.setControlValidity(HMRCPassword.ElementID, TValidityState.vsInvalid);
      SetJobMessage('You must enter your HMRC Gateway password.');
      PlaceJobButton.Enabled := False;
      SyncPlaceJobButtonVisibility;
      Exit(False);
    end;

    if not ValidateSignerIdentity(lIdentityMessage) then
    begin
      TDocUtils.setControlValidity(AuthorisedOfficial.ElementID, TValidityState.vsInvalid);
      SetJobMessage(lIdentityMessage);
      PlaceJobButton.Enabled := False;
      SyncPlaceJobButtonVisibility;
      Exit(False);
    end;

    TDocUtils.setControlValidity(AuthorisedOfficial.ElementID, TValidityState.vsValid);
    PlaceJobButton.Enabled := True;
  end
  else
  begin
    PlaceJobButton.Enabled := False;
    if not ClaimFiguresConfirmed then
      SetJobMessage('Prepared claim has no claimable values — cannot Sign and Submit.')
    else if AgreeCheckBox.Checked and (not HasDeclarationTextReady) then
      SetJobMessage('Declaration text is not loaded yet. Wait a moment, or re-open Prepare & Submit.')
    else if not AgreeCheckBox.Checked then
      ClearJobMessage;
  end;

  if PlaceJobButton.ElementID <> '' then
  begin
    if PlaceJobButton.Enabled then
    begin
      PlaceJobButton.ElementHandle.removeAttribute('disabled');
      PlaceJobButton.ElementHandle.classList.remove('disabled');
    end
    else
      PlaceJobButton.ElementHandle.setAttribute('disabled', 'disabled');
  end;

  // Enabled updates from TMS can clear the JS display:none - re-apply step visibility.
  SyncPlaceJobButtonVisibility;
end;

procedure TGiftAidClaimJob.ConfigDatasetAfterOpen(Dataset: TDataSet);
const
  _Filter = '$filter=(Status eq ''Active'') and (HMRCValidation eq ''Validated'')';
begin
  inherited;
  AuthOfficials.QueryString := _Filter;
  AuthOfficials.Load;
end;

procedure TGiftAidClaimJob.ConfirmClaimCheckBoxClick(Sender: TObject);
begin
  if (not ConfirmClaimCheckBox.Checked) and FDeclarationSigned then
  begin
    await(InvalidateDeclarationForClaimDataChange(
      'Confirm Claim was cleared — declaration revoked. Confirm the figures again, then Sign.'));
    Exit;
  end;

  if not ConfirmClaimCheckBox.Checked then
    AgreeCheckBox.Checked := False;

  { Re-evaluate Agree / Sign from confirmed prepare figures. }
  UpdateDeclarationActionState;
  CanPlaceJob;
  SyncPlaceJobButtonVisibility;
end;

procedure TGiftAidClaimJob.GetUnclaimedValues;
var
  lRetval: TXDataClientResponse;
  lResult: JS.TJSObject;
begin
//KSS  lRetval := await(TXDataClientResponse,
//KSS    MainData.WebClient.RawInvokeAsync('IGiftAiderService.UnclaimedDonationSummary', []));
//KSS  lResult := lRetval.ResultAsObject;

end;

procedure TGiftAidClaimJob.HMRCPasswordChange(Sender: TObject);
begin
  CanPlaceJob;
end;

procedure TGiftAidClaimJob.HMRCPasswordExit(Sender: TObject);
begin
  inherited;
  CanPlaceJob;
end;

function TGiftAidClaimJob.JobClass: string;
begin
  case FJobToPlace of
    cjpPrepareClaim:
      Result := 'TPrepareClaimJob';
    cjpSubmitPreparedClaim:
      Result := 'TClaimGiftAidJob';
  else
    Result := 'TPrepareClaimJob';
  end;
end;

function TGiftAidClaimJob.JobDescription: string;
begin
  case FJobToPlace of
    cjpPrepareClaim:
      Result := 'Preparing Gift Aid claim';
    cjpSubmitPreparedClaim:
      Result := 'Submitting prepared Gift Aid claim';
  else
    Result := 'Claiming Gift Aid';
  end;
end;

function TGiftAidClaimJob.JobDisplayName: string;
begin
  result := 'Gift Aid Claim Preparation';
end;

procedure TGiftAidClaimJob.JobParams(AJobParams: JS.TJSObject);
var
  lImportId: string;
begin
  inherited;

  lImportId := '';
  if ImportFiles.ItemIndex >= 0 then
    lImportId := Trim(ImportFiles.Value);

  { Use indexer assignment so Pas2JS JSON.stringify always keeps these keys.
    Missing ImportId / dates causes PrepareClaim to run with empty filters. }
  AJobParams['HMRCPassword'] := HMRCPassword.Text;
  if FJobToPlace = cjpSubmitPreparedClaim then
  begin
    AJobParams['HMRCOfficial'] := ClaimHmrcOfficialUserId;
    if AgentSessionActive and (FSignedByUserId > 0) then
      AJobParams['DeclarationSignedByUser'] := FSignedByUserId;
  end
  else
    AJobParams['HMRCOfficial'] := FSignerUserId;
  AJobParams['ErrorHandling'] := ErrorHandling.Value;
  AJobParams['ClaimRef'] := Trim(UserClaimRef.Text);
  { Always strings so server XSuperObject .S[] / typed GetType paths stay consistent }
  AJobParams['ClaimId'] := IntToStr(FClaimId);
  AJobParams['ImportId'] := lImportId;
  AJobParams['EarliestClaimDate'] := FormatDateTime('yyyy/mm/dd', OldestDateParameter.Date);
  AJobParams['LatestClaimDate'] := FormatDateTime('yyyy/mm/dd', NewestDateParameter.Date);
  AJobParams['MaximumGiftAidAmountForClaim'] := MaximumGiftAidAmountForClaimValue;

  { Audit payload — job persists CLAIM_DECLARATION for HMRCOfficial. }
  if FJobToPlace = cjpSubmitPreparedClaim then
  begin
    { Keep WaitingAuth + revoke declaration on pre-dispatch failure (Continue again). }
    AJobParams['RollbackPreparedClaimOnFailure'] := False;
    AJobParams['DeclarationText'] := FSignedDeclarationText;
    AJobParams['DeclarationHash'] := FDeclarationHash;
    if FDeclarationSignedAt > 0 then
      AJobParams['DeclarationSignedAt'] :=
        FormatDateTime('yyyy-mm-dd"T"hh:nn:ss', FDeclarationSignedAt);
  end;
end;

procedure TGiftAidClaimJob.LoadAuthOfficials;
begin
  { Officials come from GetHMRCAuthorisedUsers via SearchForAuthOfficials. }
  SyncSelectedAuthorisedOfficial;
end;

procedure TGiftAidClaimJob.AuthorisedOfficialChange(Sender: TObject);
var
  lWasSigned: Boolean;
begin
  if FUpdatingAuthorisedOfficials then
    Exit;

  lWasSigned := FDeclarationSigned;
  SyncSelectedAuthorisedOfficial;

  { Changing the signer invalidates any signed declaration — must Sign again. }
  if lWasSigned and (FSignerUserId <> FSignedByUserId) then
    await(InvalidateDeclarationForClaimDataChange(
      'Authorised official changed — tick I agree and Sign and Submit again.'));

  if not FDeclarationSigned then
    PopulateDeclarationText;

  UpdateDeclarationActionState;
  CanPlaceJob;
end;

function TGiftAidClaimJob.AgentSessionActive: Boolean;
begin
  Result := Assigned(MainData) and MainData.UserIsAgent;
end;

function TGiftAidClaimJob.AgentSigningAsAgent: Boolean;
begin
  Result := AgentSessionActive and SameText(FManagedAgentSubmissionType, 'AsAgent');
end;

function TGiftAidClaimJob.AgentSigningAsCharity: Boolean;
begin
  Result := AgentSessionActive and SameText(FManagedAgentSubmissionType, 'AsCharity');
end;

function TGiftAidClaimJob.PasswordVerifierUserId: Integer;
begin
  if AgentSessionActive and Assigned(MainData.AppUser) then
    Result := MainData.AppUser.InternalId
  else
    Result := FSignerUserId;
end;

function TGiftAidClaimJob.ClaimHmrcOfficialUserId: Integer;
begin
  if AgentSigningAsCharity then
    Result := FSignerUserId
  else if FSignedByUserId > 0 then
    Result := FSignedByUserId
  else
    Result := FSignerUserId;
end;

procedure TGiftAidClaimJob.SyncAgentSigningUi;
var
  lHideOfficialField: Boolean;
  lOfficialHelp, lPasswordHelp: string;
begin
  lHideOfficialField := AgentSigningAsAgent;
  if AgentSigningAsAgent then
    lOfficialHelp := 'You will sign this declaration as the logged-in agent user.'
  else if AgentSigningAsCharity then
    lOfficialHelp :=
      'Select the charity authorised official for the HMRC submission. Sign and Submit uses your agent GiftAider login password.'
  else
    lOfficialHelp :=
      'Defaults to the charity authorised official when they are eligible. You can change this; Sign and Submit still requires that person''s GiftAider login password.';

  if AgentSessionActive then
    lPasswordHelp := 'Enter your GiftAider login password to confirm your identity.'
  else
    lPasswordHelp :=
      'Enter the GiftAider login password for the selected authorised official to prove their identity.';

  {$IFDEF PAS2JS}
  asm
    var field = document.getElementById('AuthorisedOfficialField');
    var help = document.getElementById('AuthorisedOfficialHelp');
    var modalHelp = document.getElementById('SignDeclarationPasswordHelp');
    if (field) {
      field.style.display = lHideOfficialField ? 'none' : '';
    }
    if (help) {
      help.textContent = lOfficialHelp;
    }
    if (modalHelp) {
      modalHelp.textContent = lPasswordHelp;
    }
  end;
  {$ENDIF}
end;

procedure TGiftAidClaimJob.LoadManagedAgentSubmissionType;
var
  lRetval: TXDataClientResponse;
begin
  FManagedAgentSubmissionType := '';
  if not AgentSessionActive then
  begin
    SyncAgentSigningUi;
    Exit;
  end;

  if Trim(MainData.TenantId) = '' then
  begin
    SyncAgentSigningUi;
    Exit;
  end;

  try
    await(EnsureXDataConnected);
    lRetval := await(TXDataClientResponse,
      MainData.WebClient.RawInvokeAsync('IOrganisationService.GetManagedAgentSubmissionType',
        [MainData.TenantId]));
    FManagedAgentSubmissionType := string(TJSObject(lRetval.Result)['value']);
  except
    FManagedAgentSubmissionType := '';
  end;
  SyncAgentSigningUi;
end;

procedure TGiftAidClaimJob.SearchForAuthOfficials;
var
  lRetval: TXDataClientResponse;
  lResult: JS.TJSObject;
  lList: JS.TJSArray;
  lIdx: Integer;
  lInternalId: Integer;
  lFirstName, lLastName, lUserName: string;
  OffUsers: JS.TJSObject;
  lPreferId: string;
  lPreserveId: string;
  lPreserveFound: Boolean;
  lConfigOfficialId: Integer;
  lDefaultFromConfig: string;
begin
  FSignerEligible := False;
  AuthorisedOfficial.LookupValues.Clear;
  AuthorisedOfficial.ItemIndex := -1;
  { Official stays selectable so a change can revoke and force re-sign. }
  AuthorisedOfficial.Enabled := True;

  if AgentSigningAsAgent then
  begin
    if not Assigned(MainData.AppUser) or (MainData.AppUser.InternalId <= 0) then
    begin
      SyncSelectedAuthorisedOfficial;
      SetJobMessage('Your agent user session is not available. Log in again and reopen this claim.');
      SyncAgentSigningUi;
      Exit;
    end;

    AuthorisedOfficial.LookupValues.AddPair(IntToStr(MainData.AppUser.InternalId), GetUserName);
    FUpdatingAuthorisedOfficials := True;
    try
      AuthorisedOfficial.Value := IntToStr(MainData.AppUser.InternalId);
      SyncSelectedAuthorisedOfficial;
    finally
      FUpdatingAuthorisedOfficials := False;
    end;

    if Trim(FDeclarationVersionText) <> '' then
      PopulateDeclarationText
    else
      UpdateDeclarationActionState;
    CanPlaceJob;
    SyncAgentSigningUi;
    Exit;
  end;

  SyncAgentSigningUi;

  try
    await(EnsureXDataConnected);
    { Charity config official is a default only — must still be in the authorised list. }
    lConfigOfficialId := 0;
    try
      if not ConfigDataset.Active then
        ConfigDataset.Load;
      if ConfigDataset.Active and (not ConfigDataset.IsEmpty) then
        lConfigOfficialId := ConfigDatasetHMRCOfficial.AsInteger;
    except
      lConfigOfficialId := 0;
    end;

    { Service has no parameters — match CharityEdit / IUserManagerService. }
    lRetval := await(TXDataClientResponse,
      MainData.WebClient.RawInvokeAsync('IUserManagerService.GetHMRCAuthorisedUsers', []));
  except
    on E: Exception do
    begin
      SyncSelectedAuthorisedOfficial;
      SetJobMessage('Could not load HMRC authorised officials: ' + E.Message);
      Exit;
    end;
  end;

  lList := nil;
  if Assigned(lRetval) then
  begin
    try
      lResult := lRetval.ResultAsObject;
      if Assigned(lResult) then
        lList := JS.toArray(lResult['value']);
    except
      lList := nil;
    end;
    if lList = nil then
      lList := TJSArray(lRetval.Result);
  end;

  lPreferId := '';
  lPreserveId := '';
  lPreserveFound := False;
  lDefaultFromConfig := '';
  if FDeclarationSigned and (FSignedByUserId > 0) then
    lPreserveId := IntToStr(FSignedByUserId)
  else if FSignerUserId > 0 then
    lPreserveId := IntToStr(FSignerUserId);

  if lList <> nil then
  begin
    for lIdx := 0 to (lList.Length - 1) do
    begin
      OffUsers := JS.toObject(lList.Elements[lIdx]);
      lInternalId := JS.toInteger(OffUsers['InternalId']);
      if lInternalId <= 0 then
        Continue;
      lFirstName := JS.toString(OffUsers['GivenName']);
      lLastName := JS.toString(OffUsers['LastName']);
      lUserName := Trim(lFirstName + ' ' + lLastName);
      if lUserName = '' then
        lUserName := 'User ' + IntToStr(lInternalId);
      AuthorisedOfficial.LookupValues.AddPair(IntToStr(lInternalId), lUserName);
      if IntToStr(lInternalId) = lPreserveId then
        lPreserveFound := True;
      if (lConfigOfficialId > 0) and (lInternalId = lConfigOfficialId) then
        lDefaultFromConfig := IntToStr(lInternalId);
      if Assigned(MainData.AppUser) and (lInternalId = MainData.AppUser.InternalId) then
        lPreferId := IntToStr(lInternalId);
    end;
  end;

  FUpdatingAuthorisedOfficials := True;
  try
    if AuthorisedOfficial.LookupValues.Count = 0 then
    begin
      SyncSelectedAuthorisedOfficial;
      SetJobMessage('No HMRC authorised officials are available for this organisation.');
    end
    else if (lPreserveId <> '') and lPreserveFound then
      AuthorisedOfficial.Value := lPreserveId
    else if (lDefaultFromConfig <> '') and (not FDeclarationSigned) then
      { Charity config official as default when still eligible to sign. }
      AuthorisedOfficial.Value := lDefaultFromConfig
    else if (lPreferId <> '') and (not FResumingClaim) and (not FDeclarationSigned) then
      AuthorisedOfficial.Value := lPreferId
    else
      AuthorisedOfficial.ItemIndex := 0;

    AuthorisedOfficial.Enabled := True;
    SyncSelectedAuthorisedOfficial;
  finally
    FUpdatingAuthorisedOfficials := False;
  end;

  if Trim(FDeclarationVersionText) <> '' then
    PopulateDeclarationText
  else
    UpdateDeclarationActionState;
  CanPlaceJob;
end;

procedure TGiftAidClaimJob.UserClaimRefChange(Sender: TObject);
begin
  inherited;
  SyncSubmissionIdDisplay;
  UpdateDeclarationActionState;
  CanPlaceJob;
end;

function TGiftAidClaimJob.MinimumProcessLevel: string;
begin
  result := 'Anyone';//KSS 'AnyAdministrator';
end;

function TGiftAidClaimJob.DefaultRunLevel: string;
begin
  { DEBUG posts to HMRC LTS → Preview. Release posts to live HMRC → Production. }
{$IFDEF DEBUG}
  Result := 'Preview';
{$ELSE}
  Result := 'Production';
{$ENDIF}
end;

procedure TGiftAidClaimJob.ParameterChange(Sender: TObject);
begin
  if FDeclarationSigned then
    await(InvalidateDeclarationForClaimDataChange(
      'Claim selection changed — declaration revoked. Evaluate, confirm, Prepare Claim, then Sign again.'));

  FJobToPlace := cjpPrepareClaim;
  FPrepareDataReviewed := False;
  FPrepareJobCreated := False;
  if not FResumingClaim then
    FClaimId := 0;
  JobId := 0;
  ConfirmClaimCheckBox.Enabled := False;
  ConfirmClaimCheckBox.Checked := False;
  AgreeCheckBox.Checked := False;
  AgreeCheckBox.Enabled := False;
  FHasClaimablePrepare := False;
  FPartialClaimLimitExceeded := False;
  FPartialClaimAcknowledged := False;
  ClearPartialClaimLimitWarning;
  ClearEmptyPrepareClaimMessage;
  SetPlaceJobPrepareVisible(False);
  SetClaimPreparedAttribute(False);
  SyncFiguresActionButtons;
  UpdateDeclarationActionState;
  CanPlaceJob;
end;

procedure TGiftAidClaimJob.MaximumGiftAidAmountForClaimChange(Sender: TObject);
begin
  ParameterChange(Sender);
end;

procedure TGiftAidClaimJob.MaximumGiftAidAmountForClaimExit(Sender: TObject);
var
  lAmount: Double;
begin
  lAmount := MaximumGiftAidAmountForClaimValue;
  if lAmount > 0 then
    MaximumGiftAidAmountForClaim.Text := FormatFloat('0.00', lAmount)
  else
    MaximumGiftAidAmountForClaim.Text := '';
end;

function TGiftAidClaimJob.MaximumGiftAidAmountForClaimValue: Double;
begin
  if not MainData.ClaimMaxAmountEnabled then
  begin
    Result := 0;
    Exit;
  end;
  Result := StrToFloatDef(
    StringReplace(Trim(MaximumGiftAidAmountForClaim.Text), ',', '', [rfReplaceAll]), 0);
  if Result < 0 then
    Result := 0;
end;

procedure TGiftAidClaimJob.LoadMaximumGiftAidAmountForClaim;
var
  lDefaultAmount: Double;
  lGroup: TJSHTMLElement;
  lHelp: TJSHTMLElement;
begin
  Await(MainData.GetClaimMaxAmountSettings);

  MaximumGiftAidAmountForClaim.Visible := MainData.ClaimMaxAmountEnabled;
  lGroup := TJSHTMLElement(document.getElementById('MaximumGiftAidAmountForClaimGroup'));
  lHelp := TJSHTMLElement(document.getElementById('MaximumGiftAidAmountForClaimHelp'));
  if Assigned(lGroup) then
  begin
    if MainData.ClaimMaxAmountEnabled then
      lGroup.style.setProperty('display', '')
    else
      lGroup.style.setProperty('display', 'none');
  end;

  if not MainData.ClaimMaxAmountEnabled then
  begin
    MaximumGiftAidAmountForClaim.Text := '';
    MaximumGiftAidAmountForClaim.Enabled := False;
    Exit;
  end;

  if MainData.ServerClaimMaxAmount > 0 then
  begin
    lDefaultAmount := MainData.ServerClaimMaxAmount;
    MaximumGiftAidAmountForClaim.Enabled := False;
    if Assigned(lHelp) then
      lHelp.innerHTML := 'Set by the server and cannot be changed for this claim.';
  end
  else
  begin
    lDefaultAmount := 0;
    if Assigned(MainData.OrganisationConfiguration) then
      lDefaultAmount := MainData.OrganisationConfiguration.MaxClaimAmount;
    MaximumGiftAidAmountForClaim.Enabled := not FPrepareJobCreated;
    if Assigned(lHelp) then
      lHelp.innerHTML := 'Defaults from Charity Details. Change it here for this claim only; leave blank for no amount limit.';
  end;

  if lDefaultAmount > 0 then
    MaximumGiftAidAmountForClaim.Text := FormatFloat('0.00', lDefaultAmount)
  else
    MaximumGiftAidAmountForClaim.Text := '';

  if FPrepareJobCreated then
    MaximumGiftAidAmountForClaim.Enabled := False;
end;

procedure TGiftAidClaimJob.PlaceJobButtonClick(Sender: TObject);
begin
  { Import "All" is value 0 — do not treat that as missing. }
  if ImportFiles.ItemIndex < 0 then
  begin
    SetJobMessage('Select an import file before preparing / submitting the claim.');
    Exit;
  end;
  if (OldestDateParameter.Date <= 0) or (NewestDateParameter.Date <= 0) then
  begin
    SetJobMessage('Claim date range is missing. Re-open Prepare & Submit and try again.');
    Exit;
  end;

  inherited;
  if assigned(MainPage) then
    MainPage.DisableSubmissionLink;
end;

procedure TGiftAidClaimJob.PlaceSubmissionJobButtonClick(Sender: TObject);
begin
  if not FPrepareJobCreated then
    await(PlacePrepareClaimJob(Sender))
  else
    await(PlaceSubmitPreparedClaimJob(Sender));
end;

procedure TGiftAidClaimJob.PlacePrepareClaimJob(Sender: TObject);
var
  lParams: string;
  lVisibility: string;
  lOutputOption: string;
  lRunLevel: string;
  lJobClass: string;
begin
  if not (FPrepareDataReviewed and ClaimFiguresConfirmed and HasSubmissionIdForSigning and
    PartialClaimReadyToPrepare) then
  begin
    SetJobMessage('Confirm the preview figures before Prepare Claim.');
    CanPlaceJob;
    Exit;
  end;

  { ImportFiles "All" uses value 0 — allow ItemIndex >= 0 even when Value is '0'. }
  if ImportFiles.ItemIndex < 0 then
  begin
    SetJobMessage('Select an import file before preparing the claim.');
    Exit;
  end;

  FJobToPlace := cjpPrepareClaim;
  lParams := GetParams;
  lJobClass := JobClass;
  if JobVisibility.ItemIndex >= 0 then
    lVisibility := JobVisibility.Value
  else
    lVisibility := 'Anyone';
  if OutputOption.ItemIndex >= 0 then
    lOutputOption := OutputOption.Value
  else
    lOutputOption := 'Undecided';
  if JobRunType.Visible and (JobRunType.ItemIndex >= 0) then
    lRunLevel := JobRunType.Value
  else
    lRunLevel := DefaultRunLevel;

  FClaimId := 0;
  JobId := 0;
  PrepareClaimButton.Enabled := False;
  PlaceJobButton.Enabled := False;
  ConfirmClaimCheckBox.Enabled := False;
  AgreeCheckBox.Enabled := False;
  AgreeCheckBox.Checked := False;
  UserClaimRef.Enabled := False;
  SetClaimSelectionControlsEnabled(False);
  SyncSubmissionIdDisplay;
  SetPlaceJobPrepareVisible(False);
  CloseTimer.Enabled := False;
  WaitMessage.Hide;
  PrepareWaitMessage.Hide;
  PrepareClaimTimer.Enabled := False;

  { Close immediately; MainPage schedules the job so place is not blocked on this form. }
  ModalResult := mrOK;
  if Assigned(MainPage) then
    MainPage.SchedulePrepareClaimJob(lJobClass, lVisibility, lParams, lOutputOption, lRunLevel);
end;

procedure TGiftAidClaimJob.PlaceSubmitPreparedClaimJob(Sender: TObject);
var
  lIdentityMessage: string;
begin
  if (not FPrepareJobCreated) or (FClaimId <= 0) then
  begin
    SetJobMessage('Prepare Claim must complete before Sign and Submit.');
    PlaceJobButton.Enabled := False;
    Exit;
  end;

  if not AgreeCheckBox.Checked then
  begin
    SetJobMessage('Review the declaration and tick I agree before Sign and Submit.');
    Exit;
  end;

  if not HasSubmissionIdForSigning then
  begin
    SetJobMessage('Enter your Submission ID before Sign and Submit.');
    TDocUtils.setControlValidity(UserClaimRef.ElementID, TValidityState.vsInvalid);
    Exit;
  end;

  if not ValidateSignerIdentity(lIdentityMessage) then
  begin
    SetJobMessage(lIdentityMessage);
    PlaceJobButton.Enabled := False;
    Exit;
  end;

  if not HasDeclarationTextReady then
  begin
    SetJobMessage('Declaration text is not loaded yet. Wait a moment, then try Sign and Submit again.');
    Exit;
  end;

  if not HasValidSignedDeclaration then
  begin
    ClearJobMessage;
    LoginPassword.Text := '';
    TDocUtils.setControlValidity(LoginPassword.ElementID, TValidityState.vSNone);
    ShowSignPasswordModal(True);
    Exit;
  end;

  if FSignedByUserId <= 0 then
  begin
    SetJobMessage('Cannot submit: Sign and Submit did not record an authorised official.');
    PlaceJobButton.Enabled := False;
    Exit;
  end;

  { Import "All" is value 0 — do not treat that as missing. }
  if ImportFiles.ItemIndex < 0 then
  begin
    SetJobMessage('Select an import file before preparing / submitting the claim.');
    Exit;
  end;
  if (OldestDateParameter.Date <= 0) or (NewestDateParameter.Date <= 0) then
  begin
    SetJobMessage('Claim date range is missing. Re-open Prepare & Submit and try again.');
    Exit;
  end;

  FJobToPlace := cjpSubmitPreparedClaim;
  JobId := 0;
  PlaceJobManagedExternally := False;
  PlaceJobButton.Enabled := False;
  await(PlaceJob);

  if Assigned(MainPage) then
    MainPage.DisableSubmissionLink;
end;

procedure TGiftAidClaimJob.AfterPlaceJob;
begin
  inherited;
  if FJobToPlace = cjpPrepareClaim then
  begin
    { Do not show a blocking wait spinner — PlacePrepareClaimJob closes the form. }
    CloseTimer.Enabled := False;
    WaitMessage.Hide;
    PrepareWaitMessage.Hide;
    PrepareClaimTimer.Enabled := False;
  end;
end;

procedure TGiftAidClaimJob.UserClaimRefExit(Sender: TObject);
begin
  inherited;
  SyncSubmissionIdDisplay;
  UpdateDeclarationActionState;
  CanPlaceJob;
end;

procedure TGiftAidClaimJob.CheckForRememberPassword;
var
  lRetval: TXDataClientResponse;
  lRememberPasswordEnabled: Boolean;
begin
  await(EnsureXDataConnected);
  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IUserManagerService.HMRCPasswordSavingEnabled', [1]));
  FRememberPasswordEnabled := boolean(TJSObject(lRetval.Result)['value']);
  lRememberPasswordEnabled := FRememberPasswordEnabled;

  HMRCPassword.Enabled := not FRememberPasswordEnabled;
  if FRememberPasswordEnabled then
    TDocUtils.setControlValidity(HMRCPassword.ElementID, TValidityState.vSNone);

  {$IFDEF PAS2JS}
  asm
    var help = document.getElementById('HMRCPasswordHelp');
    if (help) {
      help.textContent = lRememberPasswordEnabled
        ? 'HMRC Gateway password is saved for this organisation — you do not need to enter it here.'
        : 'Required for Sign and Submit.';
    }
  end;
  {$ENDIF}

  UpdateDeclarationActionState;
  CanPlaceJob;
end;

procedure TGiftAidClaimJob.InitialCheckTimer(Sender: TObject);
begin
  InitialCheck.Enabled := False;
  { Do not wipe a resumed claim, or prepare/confirm work already done. }
  if FResumingClaim or FPrepareJobCreated or (FClaimId > 0) or FHasClaimablePrepare or
    ConfirmClaimCheckBox.Checked then
    Exit;

  ResetClaim;
end;

procedure TGiftAidClaimJob.ClaimDeclarationAfterPost(DataSet: TDataSet);
begin
  inherited;
  ClaimDeclaration.ApplyUpdates;
end;

procedure TGiftAidClaimJob.HashClaimDeclaration;
var
  lRetval: TXDataClientResponse;
  lResponse: TJSObject;
  lDeclarationText: string;

begin

  lDeclarationText := DeclarationTextMemo.Lines.Text;

  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderService.HashDeclaration', [lDeclarationText]));

  lResponse := lRetval.ResultAsObject;
  FDeclarationHash := JS.ToString(lResponse['value']);

end;

procedure TGiftAidClaimJob.SyncSelectedAuthorisedOfficial;
begin
  FSignerUserId := StrToIntDef(Trim(AuthorisedOfficial.Value), 0);
  FSignerEligible := FSignerUserId > 0;
  if FSignerEligible then
    TDocUtils.setControlValidity(AuthorisedOfficial.ElementID, TValidityState.vsValid)
  else
    TDocUtils.setControlValidity(AuthorisedOfficial.ElementID, TValidityState.vsInvalid);
end;

function TGiftAidClaimJob.SelectedAuthorisedOfficialName: string;
begin
  if AgentSigningAsAgent then
    Result := GetUserName
  else
  begin
    Result := Trim(AuthorisedOfficial.DisplayText);
    if Result = '' then
      Result := GetUserName;
  end;
end;

function TGiftAidClaimJob.CharityOfficialDisplayName: string;
begin
  Result := Trim(AuthorisedOfficial.DisplayText);
end;

function TGiftAidClaimJob.HasSubmissionIdForSigning: Boolean;
begin
  Result := Trim(UserClaimRef.Text) <> '';
end;

function TGiftAidClaimJob.ClaimFiguresConfirmed: Boolean;
begin
  if FPrepareJobCreated then
    Result := FHasClaimablePrepare
  else
    Result := FHasClaimablePrepare and ConfirmClaimCheckBox.Checked;
end;

function TGiftAidClaimJob.PromptedLoginPassword: string;
begin
  Result := Trim(LoginPassword.Text);
end;

procedure TGiftAidClaimJob.ShowSignPasswordModal(const AShow: Boolean);
begin
  {$IFDEF PAS2JS}
  asm
    var el = document.getElementById('SignDeclarationModal');
    if (!el) {
      return;
    }
    if (AShow) {
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      var pwd = document.getElementById('LoginPassword');
      if (pwd) {
        pwd.onkeydown = function (ev) {
          if (ev.key === 'Enter') {
            ev.preventDefault();
            var ok = document.getElementById('ConfirmSignDeclarationButton');
            if (ok) {
              ok.click();
            }
          }
        };
        setTimeout(function () { pwd.focus(); }, 0);
      }
    } else {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
    }
  end;
  {$ENDIF}
end;

function TGiftAidClaimJob.VerifySignerLoginPassword(const APassword: string): Boolean;
var
  lRetval: TXDataClientResponse;
  lVerifierUserId: Integer;
begin
  Result := False;
  lVerifierUserId := PasswordVerifierUserId;
  if (lVerifierUserId <= 0) or (Trim(APassword) = '') then
    Exit;

  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderService.VerifyLoginPassword',
      [lVerifierUserId, Trim(APassword)]));
  Result := boolean(TJSObject(lRetval.Result)['value']);
end;

procedure TGiftAidClaimJob.GetGatewayId;
var
  lRetval: TXDataClientResponse;
begin
  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IUserManagerService.GetGatewayId', [1]));
  FGatewayId := string(TJSObject(lRetval.Result)['value']);

end;

procedure TGiftAidClaimJob.DisplayClaimDeclarationTimer(Sender: TObject);
begin
  DisplayClaimDeclaration.Enabled := False;
  { Kept for designer wiring; declaration load is handled by LoadAndShowDeclaration. }
end;

procedure TGiftAidClaimJob.PopulateDeclarationText;
var
  lText: string;
  lFullName: string;
  lSigningUser: string;
  lOfficialName: string;
  lTodaysDate: string;
  lCharityName: string;
begin
  lText := Trim(FDeclarationVersionText);
  if lText = '' then
  begin
    AddClaimDeclarationTextToMeno(
      'Declaration text could not be loaded.~' +
      'Check that an active declaration version exists, then re-open Prepare & Submit.');
    FDeclarationHash := '';
    UpdateDeclarationActionState;
    Exit;
  end;

  lSigningUser := GetUserName;
  lOfficialName := CharityOfficialDisplayName;
  lTodaysDate := FormatDateTime('dd/mm/yyyy', Now);
  lCharityName := MainData.OrganisationDisplayName;

  if AgentSigningAsCharity then
  begin
    if lOfficialName <> '' then
      lFullName := lSigningUser + ', on behalf of ' + lOfficialName + ', authorised official'
    else
      lFullName := lSigningUser + ', on behalf of ' + lCharityName;
  end
  else
  begin
    lFullName := SelectedAuthorisedOfficialName;
    if lFullName = '' then
      lFullName := lSigningUser;
    if lOfficialName = '' then
      lOfficialName := lFullName;
    if not AgentSessionActive then
      lSigningUser := lFullName;
  end;

  //~ is used as a deliminter in the memo to drop text down to the next line. Used <CRLF> in
  //the text as it is more meaningful to the user
  lText := StringReplace(lText, '<CRLF>', '~', [rfReplaceAll, rfIgnoreCase]);

  lText := StringReplace(lText, '[Signing User]', lSigningUser, [rfReplaceAll, rfIgnoreCase]);
  lText := StringReplace(lText, '[Authorised Official]', lOfficialName, [rfReplaceAll, rfIgnoreCase]);
  lText := StringReplace(lText, '[Full Name]', lFullName, [rfReplaceAll, rfIgnoreCase]);
  lText := StringReplace(lText, '[Your Gateway ID]', FGatewayId, [rfReplaceAll, rfIgnoreCase]);
  lText := StringReplace(lText, '[Date]', lTodaysDate, [rfReplaceAll, rfIgnoreCase]);

  lText := StringReplace(lText, '[Charity Name]', lCharityName, [rfReplaceAll, rfIgnoreCase]);

  AddClaimDeclarationTextToMeno(lText);
  DeclarationTextMemo.ReadOnly := True;
  HashClaimDeclaration;
  UpdateDeclarationActionState;
end;

function TGiftAidClaimJob.HasDeclarationTextReady: Boolean;
begin
  Result := (Trim(FDeclarationVersionText) <> '') and
    (Trim(DeclarationTextMemo.Lines.Text) <> '') and
    (Pos('Declaration text could not be loaded', DeclarationTextMemo.Lines.Text) = 0) and
    (Pos('Loading declaration', DeclarationTextMemo.Lines.Text) = 0);
end;

procedure TGiftAidClaimJob.LoadAndShowDeclaration;
begin
  { Popup can open before other pages have connected XData — same pattern as MainForm.CheckCanPrepareClaims. }
  await(EnsureXDataConnected);
  await(GetDeclarationVersionText);
  await(GetGatewayId);
  PopulateDeclarationText;
end;

procedure TGiftAidClaimJob.GetDeclarationVersionText;
var
  lRetval: TXDataClientResponse;
begin
  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderService.GetDeclarationVersionText', []));
  FDeclarationVersionText := string(TJSObject(lRetval.Result)['value']);
end;

procedure TGiftAidClaimJob.AddClaimDeclarationTextToMeno(AText: string);
begin
  DeclarationTextMemo.Clear;
  DeclarationTextMemo.ReadOnly := True;
  DeclarationTextMemo.Lines.StrictDelimiter := True;
  DeclarationTextMemo.Lines.Delimiter := '~';
  DeclarationTextMemo.Lines.DelimitedText := AText;
end;

function TGiftAidClaimJob.ValidateSignerIdentity(out AMessage: string): Boolean;
begin
  Result := False;
  AMessage := '';

  if AgentSigningAsAgent then
  begin
    if not Assigned(MainData.AppUser) or (MainData.AppUser.InternalId <= 0) then
    begin
      AMessage := 'Your agent user session is not available. Log in again and reopen this claim.';
      Exit;
    end;
    FSignerEligible := True;
    FSignerUserId := MainData.AppUser.InternalId;
    Result := True;
    Exit;
  end;

  SyncSelectedAuthorisedOfficial;
  if not FSignerEligible then
  begin
    if AgentSigningAsCharity then
      AMessage :=
        'Select the charity authorised official who will be named on the HMRC submission.'
    else
      AMessage :=
        'Select an HMRC authorised official before signing or submitting this claim.';
    Exit;
  end;

  Result := True;
end;

function TGiftAidClaimJob.HasValidSignedDeclaration: Boolean;
begin
  { Session sign only — never rehydrate FDeclarationSigned from ClaimDeclaration.
    Expiry is not enforced in the portal; submission job records signed time. }
  Result := FDeclarationSigned;
end;

procedure TGiftAidClaimJob.SignActiveClaimDeclaration;
var
  lIdentityMessage: string;
  lPassword: string;
begin
  if (not FPrepareJobCreated) or (FClaimId <= 0) or (not ClaimFiguresConfirmed) then
  begin
    ShowSignPasswordModal(False);
    SetJobMessage('Evaluate, Confirm Claim, and Prepare Claim before signing the declaration.');
    ShowClaimWizardStep(2);
    Exit;
  end;

  if not AgreeCheckBox.Checked then
  begin
    SetJobMessage('Review the declaration and tick I agree before Sign and Submit.');
    Exit;
  end;

  if not HasSubmissionIdForSigning then
  begin
    SetJobMessage('Enter your Submission ID before Sign and Submit.');
    Exit;
  end;

  if not ValidateSignerIdentity(lIdentityMessage) then
  begin
    SetJobMessage(lIdentityMessage);
    Exit;
  end;

  lPassword := PromptedLoginPassword;
  if lPassword = '' then
  begin
    TDocUtils.setControlValidity(LoginPassword.ElementID, TValidityState.vsInvalid);
    if AgentSessionActive then
      SetJobMessage('Enter your GiftAider login password to confirm your identity.')
    else
      SetJobMessage('Enter the GiftAider login password for the selected authorised official.');
    Exit;
  end;

  if not await(Boolean, VerifySignerLoginPassword(lPassword)) then
  begin
    TDocUtils.setControlValidity(LoginPassword.ElementID, TValidityState.vsInvalid);
    if AgentSessionActive then
      SetJobMessage('Login password is incorrect for your agent user account.')
    else
      SetJobMessage('Login password is incorrect for the selected authorised official.');
    Exit;
  end;
  TDocUtils.setControlValidity(LoginPassword.ElementID, TValidityState.vsValid);

  LoginPassword.Text := '';
  ShowSignPasswordModal(False);

  if FDeclarationHash.Trim.IsEmpty then
  begin
    SetJobMessage('Declaration hash is not ready yet. Wait for the declaration text to finish loading, then try again.');
    Exit;
  end;

  if (not FPrepareJobCreated) or (FClaimId <= 0) then
  begin
    SetJobMessage('Prepare Claim must complete before Sign and Submit.');
    ShowClaimWizardStep(2);
    Exit;
  end;

  FSignedDeclarationText := DeclarationTextMemo.Lines.Text;
  FDeclarationSignedAt := Now;

  { Session sign only — CLAIM_DECLARATION row is written by TClaimGiftAidJob. }
  FDeclarationSigned := True;
  if AgentSessionActive then
    FSignedByUserId := PasswordVerifierUserId
  else
    FSignedByUserId := FSignerUserId;
  AgreeCheckBox.Checked := True;
  LockDeclarationControls(True);
  ClearJobMessage;
  UpdateDeclarationActionState;
  CanPlaceJob;
  await(PlaceSubmitPreparedClaimJob(nil));
end;

procedure TGiftAidClaimJob.LockDeclarationControls(const ALocked: Boolean);
begin
  { Official stays selectable after sign so changing it can revoke and force re-sign. }
  AuthorisedOfficial.Enabled := True;
  DeclarationTextMemo.ReadOnly := True;
  AgreeCheckBox.Enabled := (not ALocked) and ClaimFiguresConfirmed and FSignerEligible;
  { Submission ID locks once signed (session) or when resuming a prepared claim. }
  if ALocked or FDeclarationSigned or FResumingClaim or (FClaimId > 0) then
    UserClaimRef.Enabled := False
  else
    UserClaimRef.Enabled := True;
  SyncSubmissionIdDisplay;
end;

procedure TGiftAidClaimJob.UpdateDeclarationActionState;
var
  lCanAgree: Boolean;
  lStatusText: string;
  lStatusClass: string;
begin
  { Agree only after Prepare Claim job has created the claim with actual figures. }
  lCanAgree := (not FDeclarationSigned) and FPrepareJobCreated and (FClaimId > 0) and
    ClaimFiguresConfirmed and FSignerEligible;
  AgreeCheckBox.Enabled := lCanAgree;
  if FDeclarationSigned then
    AgreeCheckBox.Checked := True
  else if not lCanAgree then
    AgreeCheckBox.Checked := False;

  if FDeclarationSigned then
  begin
    if AgentSigningAsCharity and (CharityOfficialDisplayName <> '') then
      lStatusText := 'Signed by ' + GetUserName + ' on behalf of ' +
        CharityOfficialDisplayName + ' — submitting…'
    else if AgentSessionActive then
      lStatusText := 'Signed by ' + GetUserName + ' — submitting…'
    else
      lStatusText := 'Signed by ' + SelectedAuthorisedOfficialName + ' — submitting…';
    lStatusClass := 'text-success fw-semibold';
  end
  else if not FSignerEligible then
  begin
    if AgentSigningAsAgent then
      lStatusText := 'Your agent user session is not available — log in again and reopen this claim'
    else if AgentSigningAsCharity then
      lStatusText := 'Select the charity authorised official before Sign and Submit'
    else
      lStatusText := 'Select an HMRC authorised official before Sign and Submit';
    lStatusClass := 'text-danger fw-semibold';
  end
  else if not HasDeclarationTextReady then
  begin
    lStatusText := 'Waiting for declaration text to load…';
    lStatusClass := 'text-warning fw-semibold';
  end
  else if not FPrepareJobCreated then
  begin
    lStatusText := 'On step 2: Evaluate, Confirm Claim, then Prepare Claim before signing';
    lStatusClass := 'text-warning fw-semibold';
  end
  else if FClaimId <= 0 then
  begin
    lStatusText := 'Waiting for Prepare Claim to finish creating the claim…';
    lStatusClass := 'text-warning fw-semibold';
  end
  else if not FHasClaimablePrepare then
  begin
    lStatusText := 'Prepared claim has no claimable values — cannot Sign and Submit';
    lStatusClass := 'text-warning fw-semibold';
  end
  else if not HasSubmissionIdForSigning then
  begin
    lStatusText := 'Enter your Submission ID on step 2 before Prepare Claim';
    lStatusClass := 'text-warning fw-semibold';
  end
  else if AgreeCheckBox.Checked then
  begin
    lStatusText := 'Declaration accepted — click Sign and Submit (login password required)';
    lStatusClass := 'text-warning fw-semibold';
    ClearJobMessage;
  end
  else
  begin
    lStatusText := 'Review the actual prepared figures, tick I agree, then Sign and Submit';
    lStatusClass := 'text-secondary';
  end;

  {$IFDEF PAS2JS}
  asm
    var status = document.getElementById('DeclarationStatusText');
    if (status) {
      status.textContent = lStatusText;
      status.className = lStatusClass;
    }
  end;
  {$ENDIF}
end;

procedure TGiftAidClaimJob.ConfirmSignDeclarationButtonClick(Sender: TObject);
begin
  await(SignActiveClaimDeclaration);
end;

procedure TGiftAidClaimJob.CancelSignDeclarationButtonClick(Sender: TObject);
begin
  LoginPassword.Text := '';
  ShowSignPasswordModal(False);
end;

procedure TGiftAidClaimJob.LoginPasswordKeyPress(Sender: TObject; var Key: Char);
begin
  if Key = #13 then
  begin
    Key := #0;
    ConfirmSignDeclarationButtonClick(Sender);
  end;
end;

function TGiftAidClaimJob.GetUserName: string;
begin
  result := MainData.AppUser.GivenName + ' ' + MainData.AppUser.LastName;
end;

procedure TGiftAidClaimJob.GetPrepareClaimPreviewData;
var
  lRetval: TXDataClientResponse;
  lPrepareClaimData: TPrepareClaimData;
  lResponse: TJSObject;
  lImportId: string;
begin
  lImportId := ImportFiles.Value;

  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderService.PrepareClaimDataDirect',
      [lImportId.ToInteger, OldestDateParameter.Date, NewestDateParameter.Date,
       MaximumGiftAidAmountForClaimValue]));

  lResponse := lRetval.ResultAsObject;
  lPrepareClaimData := TPrepareClaimData.Create;
  try
    lPrepareClaimData.Assign(lResponse);
    PrepareWaitMessage.Hide;
    FPrepareDataReviewed := True;
    FPrepareJobCreated := False;
    FJobToPlace := cjpPrepareClaim;
    PopulatePrepareGrid(lPrepareClaimData);
  finally
    lPrepareClaimData.Free;
  end;
end;

procedure TGiftAidClaimJob.GetPrepareClaimData;
var
  lRetval: TXDataClientResponse;
  lPrepareClaimData: TPrepareClaimData;
  lResponse: TJSObject;
begin
  if JobId = 0 then
    Exit;

  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderService.PrepareClaimData', [JobId]));

  lResponse := lRetval.ResultAsObject;
  lPrepareClaimData := TPrepareClaimData.Create;
  try
    lPrepareClaimData.Assign(lResponse);

    if lPrepareClaimData.Complete then
    begin
      PrepareWaitMessage.Hide;
      FClaimId := lPrepareClaimData.ClaimId;
      FPrepareJobCreated := True;
      FJobToPlace := cjpSubmitPreparedClaim;
      PopulatePrepareGrid(lPrepareClaimData);
      UpdateClaimFormForSubmission;
      ShowClaimWizardStep(2);
      if Assigned(MainPage) then
        MainPage.NotifyPrepareClaimReady(Trim(UserClaimRef.Text), True);
      SetJobMessage(
        'Prepare Claim finished. Review the actual figures, then Continue to Sign and Submit.');
    end
    else
    begin
      { Incomplete poll must not wipe the evaluate preview or show "Nothing to prepare". }
      PrepareWaitMessage.Hide;
      PrepareClaimTimer.Enabled := True;
    end;
  finally
    lPrepareClaimData.Free;
  end;
end;

procedure TGiftAidClaimJob.PrepareClaimButtonClick(Sender: TObject);
var
  lKeepClaimRef: string;
begin
  if ImportFiles.ItemIndex < 0 then
    Exit;

  if FDeclarationSigned then
    await(InvalidateDeclarationForClaimDataChange(
      'Evaluate Claim changed the figures — declaration revoked. Confirm, Prepare Claim, then Sign again.'));

  lKeepClaimRef := Trim(UserClaimRef.Text);

  ClearPreparePreview;
  FHasClaimablePrepare := False;
  FPrepareDataReviewed := False;
  FPrepareJobCreated := False;
  FJobToPlace := cjpPrepareClaim;
  ConfirmClaimCheckBox.Checked := False;
  AgreeCheckBox.Checked := False;
  AgreeCheckBox.Enabled := False;

  if not FResumingClaim then
    FClaimId := 0;
  JobId := 0;
  UserClaimRef.Text := lKeepClaimRef;
  UserClaimRef.Enabled := not FResumingClaim;
  SyncSubmissionIdDisplay;
  SetPlaceJobPrepareVisible(False);
  SetClaimPreparedAttribute(False);

  PrepareWaitMessage.Show;
  await(GetPrepareClaimPreviewData);
  UpdateDeclarationActionState;
  CanPlaceJob;
end;

procedure TGiftAidClaimJob.PrepareClaimTimerTimer(Sender: TObject);
begin
  PrepareClaimTimer.Enabled := False;
  PrepareClaimTimer.Interval := 10000;
  if JobId <> 0 then
    GetPrepareClaimData;
end;

procedure TGiftAidClaimJob.PopulatePrepareGrid(APrepareClaimData: TPrepareClaimData);
var
  lCol: integer;
  lDonationCount: integer;
  lAmount: Currency;
  lGiftAid: Currency;
begin
  { Preview: limit-included totals. Prepared: actual claim figures. }
  if (not FPrepareJobCreated) and
    (APrepareClaimData.LimitExceeded or APrepareClaimData.NothingFitsLimit) then
  begin
    lDonationCount := APrepareClaimData.IncludedDonationCount;
    lAmount := APrepareClaimData.IncludedAmount;
    lGiftAid := APrepareClaimData.IncludedGiftAid;
  end
  else
  begin
    lDonationCount := APrepareClaimData.DonationCount;
    lAmount := APrepareClaimData.Amount;
    lGiftAid := APrepareClaimData.GiftAid;
  end;

  PrepareClaimData.Cells[0,1] := IntToStr(lDonationCount);
  lCol := 1; //Current
  AddPrepareDataColumn(lCol, 'Amount', lAmount);
  AddPrepareDataColumn(lCol, 'Gift Aid', lGiftAid);

  AddPrepareDataColumn(lCol, 'GASDS', APrepareClaimData.GASDS);
  AddPrepareDataColumn(lCol, 'GASDS Adj.', APrepareClaimData.GASDSAdjustments);
  AddPrepareDataColumn(lCol, 'Aggregated', APrepareClaimData.AggregatedDonations);
  AddPrepareDataColumn(lCol, 'Other Inc.', APrepareClaimData.OtherIncome);
  AddPrepareDataColumn(lCol, 'Adj.', APrepareClaimData.Adjustments);
  AddPrepareDataColumn(lCol, 'Comm. Build', APrepareClaimData.CommunityBuildings);

  UpdateEmptyPrepareClaimMessage(APrepareClaimData);
  if not FPrepareJobCreated then
    UpdatePartialClaimLimitWarning(APrepareClaimData)
  else
    ClearPartialClaimLimitWarning;

  FHasClaimablePrepare := APrepareClaimData.Complete and HasClaimablePrepareResult(APrepareClaimData);

  if FHasClaimablePrepare and (not FPrepareJobCreated) then
  begin
    ConfirmClaimCheckBox.Enabled := True;
    CancelPrepareClaimButton.Enabled := True;
  end
  else if not FHasClaimablePrepare then
  begin
    ConfirmClaimCheckBox.Enabled := False;
    ConfirmClaimCheckBox.Checked := False;
    AgreeCheckBox.Enabled := False;
    AgreeCheckBox.Checked := False;
  end;

  if APrepareClaimData.Complete then
  begin
    PrepareClaimTimer.Enabled := False;
    PrepareWaitMessage.Hide;
    ClearJobMessage;
    if FPrepareJobCreated then
      UpdateClaimFormForSubmission;
  end
  else if (JobId <> 0) and (not APrepareClaimData.Complete) then
    PrepareClaimTimer.Enabled := True;

  UpdateDeclarationActionState;
  CanPlaceJob;
  SyncPlaceJobButtonVisibility;
end;

function TGiftAidClaimJob.HasClaimablePrepareResult(APrepareClaimData: TPrepareClaimData): Boolean;
begin
  // Nothing to authorise when there are no donations and none fit the amount limit,
  // or when there simply are no claimable donations in the selection.
  Result := not APrepareClaimData.NothingFitsLimit;
  if not Result then
    Exit;

  if APrepareClaimData.LimitExceeded then
    Result := (APrepareClaimData.IncludedDonationCount > 0) or
      (APrepareClaimData.Adjustments <> 0)
  else
    Result := (APrepareClaimData.DonationCount > 0) or
      (APrepareClaimData.Adjustments <> 0);
end;

function TGiftAidClaimJob.PartialClaimReadyToPrepare: Boolean;
begin
  Result := (not FNothingToClaim) and
    ((not FPartialClaimLimitExceeded) or FPartialClaimAcknowledged);
end;

procedure TGiftAidClaimJob.SyncPlaceJobButtonVisibility;
begin
  {$IFDEF PAS2JS}
  asm
    var root = document.querySelector('.smxGiftAidClaimForm');
    if (root && window.smxSyncGiftAidClaimState) {
      window.smxSyncGiftAidClaimState(root);
    }
  end;
  {$ENDIF}
end;

procedure TGiftAidClaimJob.SetPlaceJobPrepareVisible(AVisible: Boolean);
begin
  {$IFDEF PAS2JS}
  asm
    var placeJobButton = document.getElementById('PlaceJobButton');
    if (placeJobButton) {
      if (AVisible) {
        placeJobButton.setAttribute('data-prepare-visible', 'true');
      } else {
        placeJobButton.removeAttribute('data-prepare-visible');
      }
    }
  end;
  {$ENDIF}
  SyncPlaceJobButtonVisibility;
end;

procedure TGiftAidClaimJob.SetClaimPreparedAttribute(APrepared: Boolean);
begin
  {$IFDEF PAS2JS}
  asm
    var root = document.querySelector('.smxGiftAidClaimForm');
    if (root) {
      if (APrepared) {
        root.setAttribute('data-claim-prepared', 'true');
      } else {
        root.removeAttribute('data-claim-prepared');
      }
    }
  end;
  {$ENDIF}
  SyncPlaceJobButtonVisibility;
end;

procedure TGiftAidClaimJob.ClearPartialClaimLimitWarning;
begin
  FPartialClaimLimitExceeded := False;
  FPartialClaimAcknowledged := False;
  AcknowledgePartialClaim.Checked := False;
  {$IFDEF PAS2JS}
  asm
    var warning = document.getElementById('PartialClaimLimitWarning');
    var details = document.getElementById('PartialClaimLimitDetails');
    if (warning) {
      warning.style.display = 'none';
    }
    if (details) {
      details.innerHTML = '';
    }
  end;
  {$ENDIF}
  SyncPlaceJobButtonVisibility;
end;

procedure TGiftAidClaimJob.ClearEmptyPrepareClaimMessage;
begin
  FNothingToClaim := False;
  {$IFDEF PAS2JS}
  asm
    var emptyMsg = document.getElementById('EmptyPrepareClaimMessage');
    var emptyText = document.getElementById('EmptyPrepareClaimMessageText');
    if (emptyMsg) {
      emptyMsg.style.display = 'none';
    }
    if (emptyText) {
      emptyText.innerHTML = '';
    }
  end;
  {$ENDIF}
  SyncPlaceJobButtonVisibility;
end;

procedure TGiftAidClaimJob.UpdateEmptyPrepareClaimMessage(APrepareClaimData: TPrepareClaimData);
var
  lMessage: string;
begin
  ClearEmptyPrepareClaimMessage;

  if APrepareClaimData.NothingFitsLimit then
  begin
    FNothingToClaim := True;
    lMessage :=
      'No donations fit within the maximum Gift Aid amount for this claim. ' +
      'Try a higher limit, or clear the limit.';
  end
  else if (not APrepareClaimData.LimitExceeded) and (APrepareClaimData.DonationCount <= 0) then
  begin
    FNothingToClaim := True;
    lMessage := 'No claimable donations were found for this selection.';
  end
  else if APrepareClaimData.LimitExceeded and (APrepareClaimData.IncludedDonationCount <= 0) then
  begin
    FNothingToClaim := True;
    lMessage := 'No claimable donations were found for this selection.';
  end
  else
    Exit;

  {$IFDEF PAS2JS}
  asm
    var emptyMsg = document.getElementById('EmptyPrepareClaimMessage');
    var emptyText = document.getElementById('EmptyPrepareClaimMessageText');
    if (emptyText) {
      emptyText.innerHTML = lMessage;
    }
    if (emptyMsg) {
      emptyMsg.style.display = '';
    }
  end;
  {$ENDIF}
  SyncPlaceJobButtonVisibility;
end;

procedure TGiftAidClaimJob.UpdatePartialClaimLimitWarning(APrepareClaimData: TPrepareClaimData);
var
  lDetailsHtml: string;
  lMaxAmountText: string;
begin
  FPartialClaimLimitExceeded := APrepareClaimData.LimitExceeded;
  FPartialClaimAcknowledged := False;
  AcknowledgePartialClaim.Checked := False;

  // Empty / nothing-fits is handled separately — not a partial claim.
  if APrepareClaimData.NothingFitsLimit or (not APrepareClaimData.LimitExceeded) or
     (APrepareClaimData.IncludedDonationCount <= 0) then
  begin
    ClearPartialClaimLimitWarning;
    Exit;
  end;

  if APrepareClaimData.MaxClaimAmount > 0 then
    lMaxAmountText := Format(' / Gift Aid limit %s', [FormatFloat('£#,##0.00', APrepareClaimData.MaxClaimAmount)])
  else
    lMaxAmountText := '';

  lDetailsHtml :=
    '<div><strong>Effective limit:</strong> ' + FormatFloat('#,##0', APrepareClaimData.MaxClaimCount) +
    ' donations' + lMaxAmountText + '</div>' +
    '<div class="mt-2"><strong>Eligible selection:</strong> ' +
    FormatFloat('#,##0', APrepareClaimData.DonationCount) + ' donations, ' +
    FormatFloat('£#,##0.00', APrepareClaimData.Amount) + ' amount, ' +
    FormatFloat('£#,##0.00', APrepareClaimData.EligibleGiftAid) + ' Gift Aid</div>' +
    '<div class="mt-1"><strong>Remaining unclaimed:</strong> ' +
    FormatFloat('#,##0', APrepareClaimData.RemainingDonationCount) + ' donations, ' +
    FormatFloat('£#,##0.00', APrepareClaimData.RemainingAmount) + ' amount, ' +
    FormatFloat('£#,##0.00', APrepareClaimData.RemainingGiftAid) + ' Gift Aid</div>' +
    '<div class="mt-2">The preview above shows only the limited portion that will be prepared in this claim.</div>';

  {$IFDEF PAS2JS}
  asm
    var warning = document.getElementById('PartialClaimLimitWarning');
    var details = document.getElementById('PartialClaimLimitDetails');
    if (details) {
      details.innerHTML = lDetailsHtml;
    }
    if (warning) {
      warning.style.display = '';
    }
  end;
  {$ENDIF}
  SyncPlaceJobButtonVisibility;
end;

procedure TGiftAidClaimJob.AddPrepareDataColumn(var ACol: integer; AHeader: string; AValue: Currency);
begin
  if AValue <> 0.00 then
  begin
    inc(ACol);
    PrepareClaimData.ColCount := ACol;
    PrepareClaimData.Cells[ACol-1,0] := AHeader;
    PrepareClaimData.Cells[ACol-1,1] := TUtils.FormatGBP(AValue);
  end;
end;

procedure TGiftAidClaimJob.GetClaimParameters;
var
  lRetval: TXDataClientResponse;
  lClaimParameters: TClaimParameters;
  lUserClaimRef: string;
  lInt: integer;
  lResponse: TJSObject;

begin
  await(EnsureXDataConnected);
  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderService.GetClaimParameters', []));

  lResponse := lRetval.ResultAsObject;
  lClaimParameters := TClaimParameters.Create;
  lClaimParameters.Assign(lResponse);

  SetClaimParameters(lClaimParameters);
end;

procedure TGiftAidClaimJob.SyncFiguresActionButtons;
var
  lShow: Boolean;

  procedure SyncButton(AButton: TButton; const AElementId: string);
  var
    lEl: TJSHTMLElement;
  begin
    if Assigned(AButton) then
    begin
      AButton.Visible := lShow;
      AButton.Enabled := lShow;
    end;

    lEl := TJSHTMLElement(document.getElementById(AElementId));
    if Assigned(lEl) then
    begin
      if lShow then
        lEl.style.removeProperty('display')
      else
        lEl.style.setProperty('display', 'none');
    end;
  end;

begin
  lShow := FPrepareJobCreated and (FClaimId > 0);
  SyncButton(DownloadDonationsButton, 'DownloadDonationsButton');
  SyncButton(ViewAdjustmentsButton, 'ViewAdjustmentsButton');
end;

procedure TGiftAidClaimJob.SetClaimSelectionControlsEnabled(AEnabled: Boolean);
begin
  ImportFiles.Enabled := AEnabled;
  OldestDateParameter.Enabled := AEnabled;
  NewestDateParameter.Enabled := AEnabled;

  { Max amount stays locked when the server sets it, even if selection is editable. }
  if not AEnabled then
    MaximumGiftAidAmountForClaim.Enabled := False
  else if MainData.ClaimMaxAmountEnabled and (MainData.ServerClaimMaxAmount <= 0) then
    MaximumGiftAidAmountForClaim.Enabled := True
  else
    MaximumGiftAidAmountForClaim.Enabled := False;
end;

procedure TGiftAidClaimJob.DownloadDonationsButtonClick(Sender: TObject);
var
  lRetval: TXDataClientResponse;
  lData: string;
  lFileName: string;
  lClaimRef: string;
begin
  if FClaimId <= 0 then
    Exit;

  DownloadDonationsButton.Enabled := False;
  try
    lRetval := await(TXDataClientResponse,
      MainData.WebClient.RawInvokeAsync('IGiftAiderUtilsService.CreateExportFile', [FClaimId]));
    lData := JS.toString(lRetval.ResultAsObject['value']);
    lClaimRef := Trim(UserClaimRef.Text);
    if lClaimRef = '' then
      lFileName := Format('GiftAider-ClaimRef_%d.csv', [FClaimId])
    else
      lFileName := Format('GiftAider-%s.csv', [lClaimRef]);
    Application.DownloadTextFile(lData, lFileName);
  finally
    DownloadDonationsButton.Enabled := FClaimId > 0;
  end;
end;

procedure TGiftAidClaimJob.ViewAdjustmentsButtonClick(Sender: TObject);
var
  AForm: TClaimAdjustmentsPopup;
begin
  if FClaimId <= 0 then
    Exit;

  AForm := TClaimAdjustmentsPopup.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    AForm.ElementClassName := 'PopUpForm';
    AForm.ClaimId := FClaimId;
    AForm.ClaimStatus := 'WaitingAuth';
    AForm.PopupTitle := 'Adjustments in this claim';
    await(TForm, AForm.Load());
    AForm.AfterCreated;
    await(TModalResult, AForm.Execute);
  finally
    AForm.Free;
    AForm := nil;
  end;
end;

procedure TGiftAidClaimJob.UpdateClaimFormForSubmission;
begin
  FJobToPlace := cjpSubmitPreparedClaim;
  FPrepareJobCreated := True;
  ConfirmClaimCheckBox.Checked := True;
  ConfirmClaimCheckBox.Enabled := False;
  CancelPrepareClaimButton.Enabled := True;
  PrepareClaimButton.Enabled := False;
  UserClaimRef.Enabled := False;
  SetClaimSelectionControlsEnabled(False);
  AuthorisedOfficial.Enabled := True;
  SyncSubmissionIdDisplay;
  SetPlaceJobPrepareVisible(False);
  SetClaimPreparedAttribute(True);
  SyncFiguresActionButtons;
  UpdateDeclarationActionState;
  CanPlaceJob;
end;

procedure TGiftAidClaimJob.SetClaimParameters(AClaimParameters: TClaimParameters);
var
  lOldestDate, lNewestDate: TDate;
  lIdx: integer;
  lImportFileNames: TStringList;
  lImportIds: TStringList;
  lImportFileName: string;
  lImportId: string;

begin
  lImportFileNames := TStringList.Create;
  lImportFileNames.StrictDelimiter := True;
  lImportFileNames.CommaText := AClaimParameters.ImportFiles;
  lImportIds := TStringList.Create;
  lImportIds.StrictDelimiter := True;
  lImportIds.CommaText := AClaimParameters.ImportIds;

  try
    for lIdx := 0  to lImportFileNames.Count-1 do
    begin
      lImportFileName := lImportFileNames[lIdx];
      lImportId := lImportIds[lIdx];
      ImportFiles.LookupValues.AddPair(lImportId, lImportFileName);
    end;

    if lIdx > -1 then
      ImportFiles.ItemIndex := 0;

    lOldestDate := strtodate(AClaimParameters.OldestDate);
    lNewestDate := strtodate(AClaimParameters.NewestDate);

  finally
    lImportFileNames.Free;
    lImportIds.Free;
  end;
  OldestDateParameter.Date := lOldestDate;
  NewestDateParameter.Date := lNewestDate;
end;

procedure TGiftAidClaimJob.CancelPrepareClaim;
var
  lClaimRef: string;
begin
  { Disabled for the request; stays off until a new preview/prepare exists. }
  CancelPrepareClaimButton.Enabled := False;

  if FDeclarationSigned then
    await(InvalidateDeclarationForClaimDataChange(
      'Prepare was cancelled — declaration revoked. Evaluate, confirm, Prepare Claim, then Sign again.'));

  if FPrepareJobCreated and (FClaimId > 0) then
  begin
    lClaimRef := Trim(UserClaimRef.Text);
    try
      await(ResetPrepareClaim);
    except
      on E: Exception do
      begin
        CancelPrepareClaimButton.Enabled := True;
        SetJobMessage('Could not cancel the prepared claim: ' + E.Message);
        Exit;
      end;
    end;
    FPrepareJobCreated := False;
    FPrepareDataReviewed := False;
    FJobToPlace := cjpPrepareClaim;
    FClaimId := 0;
    JobId := 0;
    FResumingClaim := False;
    ResetClaim;
    { Keep Submission ID so the user can Evaluate / Prepare again without retyping. }
    UserClaimRef.Text := lClaimRef;
    UserClaimRef.Enabled := True;
    SetClaimSelectionControlsEnabled(True);
    HideResumeClaimBanner;
    PrepareClaimButton.Enabled := True;
    CancelPrepareClaimButton.Enabled := False;
    SyncSubmissionIdDisplay;
    if HasSubmissionIdForSigning then
      TDocUtils.setControlValidity(UserClaimRef.ElementID, TValidityState.vsValid)
    else
      TDocUtils.setControlValidity(UserClaimRef.ElementID, TValidityState.vsInvalid);
    SetJobMessage('The prepared claim has been discarded. Enter or keep a Submission ID, Evaluate Claim, then Prepare Claim.');
    CanPlaceJob;
    Exit;
  end;

  { Preview only — clear local evaluate results. }
  ClearPreparePreview;
  FPrepareDataReviewed := False;
  FPrepareJobCreated := False;
  FJobToPlace := cjpPrepareClaim;
  FHasClaimablePrepare := False;
  ConfirmClaimCheckBox.Checked := False;
  AgreeCheckBox.Checked := False;
  AgreeCheckBox.Enabled := False;
  SetPlaceJobPrepareVisible(False);
  SetClaimPreparedAttribute(False);
  SyncFiguresActionButtons;
  SetClaimSelectionControlsEnabled(True);
  UserClaimRef.Enabled := True;
  HideResumeClaimBanner;
  UpdateDeclarationActionState;
  CanPlaceJob;
end;

procedure TGiftAidClaimJob.ResetPrepareClaim;
begin
  if FClaimId <= 0 then
    Exit;
  await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderService.ResetPrepareClaim', [FClaimId]));
end;

procedure TGiftAidClaimJob.ClearPreparePreview;
var
  lIdx: Integer;
begin
  for lIdx := 1 to PrepareClaimData.ColCount - 1 do
  begin
    PrepareClaimData.Cells[lIdx, 0] := '';
    PrepareClaimData.Cells[lIdx, 1] := '';
  end;

  PrepareClaimData.ColCount := 3;
  PrepareClaimData.Cells[0, 0] := 'Donation Count';
  PrepareClaimData.Cells[0, 1] := '0';
  PrepareClaimData.Cells[1, 0] := 'Amount';
  PrepareClaimData.Cells[1, 1] := '0.00';
  PrepareClaimData.Cells[2, 0] := 'GiftAid';
  PrepareClaimData.Cells[2, 1] := '0.00';

  CancelPrepareClaimButton.Enabled := False;
  PrepareClaimButton.Enabled := True;
  ConfirmClaimCheckBox.Enabled := False;
  ConfirmClaimCheckBox.Checked := False;
  FHasClaimablePrepare := False;
  FPartialClaimLimitExceeded := False;
  FPartialClaimAcknowledged := False;
  ClearPartialClaimLimitWarning;
  ClearEmptyPrepareClaimMessage;
end;

procedure TGiftAidClaimJob.ResetClaim;
begin
  ClearPreparePreview;

  AgreeCheckBox.Enabled := False;
  AgreeCheckBox.Checked := False;
  FDeclarationSigned := False;
  FSignedByUserId := 0;
  FSignedDeclarationText := '';
  FDeclarationSignedAt := 0;
  FPrepareDataReviewed := False;
  FPrepareJobCreated := False;
  FJobToPlace := cjpPrepareClaim;
  LoginPassword.Text := '';
  LockDeclarationControls(False);
  SetPlaceJobPrepareVisible(False);
  SetClaimPreparedAttribute(False);
  SyncFiguresActionButtons;
  UpdateDeclarationActionState;
  if not FResumingClaim then
  begin
    UserClaimRef.Text := '';
    UserClaimRef.Clear;
    UserClaimRef.ClearSelection;
    UserClaimRef.Enabled := True;
    FClaimId := 0;
  end;
  SetClaimSelectionControlsEnabled(True);
  FJobId := 0;
  CanPlaceJob;
end;


procedure TGiftAidClaimJob.LoadDFMValues;
begin
  inherited LoadDFMValues;

  AgreeCheckBox := TCheckBox.Create('AgreeCheckBox');
  AuthorisedOfficial := TLookupComboBox.Create('AuthorisedOfficial');
  ErrorHandling := TLookupComboBox.Create('ErrorHandling');
  HMRCPassword := TEdit.Create('HMRCPassword');
  UserClaimRef := TEdit.Create('UserClaimRef');
  PrepareClaimDataXXX := TTableControl.Create('PrepareClaimDataXXX');
  ConfirmClaimCheckBox := TCheckBox.Create('ConfirmClaim');
  OldestDateParameter := TDateTimePicker.Create('OldestDateParameter');
  NewestDateParameter := TDateTimePicker.Create('NewestDateParameter');
  ImportFiles := TLookupComboBox.Create('ImportReference');
  MaximumGiftAidAmountForClaim := TEdit.Create('MaximumGiftAidAmountForClaim');
  PrepareWaitMessage := TWaitMessage.Create(Self);
  CancelPrepareClaimButton := TButton.Create('CancelPrepareClaimButton');
  PrepareClaimButton := TButton.Create('PrepareClaimButton');
  DownloadDonationsButton := TButton.Create('DownloadDonationsButton');
  ViewAdjustmentsButton := TButton.Create('ViewAdjustmentsButton');
  DeclarationTextMemo := TMemo.Create('DeclarationTextMemo');
  PrepareClaimData := TTableControl.Create('PrepareClaimData');
  AcknowledgePartialClaim := TCheckBox.Create('AcknowledgePartialClaim');
  JobsPlacedDateAdded := TDateTimeField.Create(Self);
  JobsPlacedAddedBy := TIntegerField.Create(Self);
  JobsPlacedLastUpdatedBy := TIntegerField.Create(Self);
  JobsPlacedJobCategory := TStringField.Create(Self);
  JobsPlacedLastPolled := TDateTimeField.Create(Self);
  JobsPlacedPollInterval := TLargeintField.Create(Self);
  JobsPlacedPollCount := TIntegerField.Create(Self);
  AuthOfficials := TXDataWebDataSet.Create(Self);
  AuthOfficialsId := TIntegerField.Create(Self);
  AuthOfficialsFirstName := TStringField.Create(Self);
  AuthOfficialsLastName := TStringField.Create(Self);
  ConfigDataset := TXDataWebDataSet.Create(Self);
  ConfigDatasetId := TIntegerField.Create(Self);
  ConfigDatasetHMRCOfficial := TIntegerField.Create(Self);
  ConfigDatasetCharityRef := TStringField.Create(Self);
  ConfigDatasetCharityType := TStringField.Create(Self);
  ConfigDatasetGatewayId := TStringField.Create(Self);
  ConfigDatasetGatewayPassword := TStringField.Create(Self);
  ConfigDatasetRegulator := TStringField.Create(Self);
  ConfigDatasetRegulatorNumber := TStringField.Create(Self);
  ConfigDatasetEndOfYear := TStringField.Create(Self);
  ConfigDatasetOrganisationType := TStringField.Create(Self);
  ConfigDatasetOrganisationName := TStringField.Create(Self);
  ConfigDatasetSubmissionMethod := TStringField.Create(Self);
  GAUsers := TClientDataSet.Create(Self);
  InitialCheck := TTimer.Create(Self);
  DisplayClaimDeclaration := TTimer.Create(Self);
  ClaimDeclaration := TXDataWebDataSet.Create(Self);
  ClaimDeclarationId := TIntegerField.Create(Self);
  ClaimDeclarationDateAdded := TDateTimeField.Create(Self);
  ClaimDeclarationAddedBy := TIntegerField.Create(Self);
  ClaimDeclarationLastUpdatedBy := TIntegerField.Create(Self);
  ClaimDeclarationLastUpdated := TDateTimeField.Create(Self);
  ClaimDeclarationClaimId := TIntegerField.Create(Self);
  ClaimDeclarationDeclarationVersion := TIntegerField.Create(Self);
  ClaimDeclarationDeclarationHash := TStringField.Create(Self);
  ClaimDeclarationDeclarationIssueDate := TDateTimeField.Create(Self);
  ClaimDeclarationDeclarationExpiryDate := TDateTimeField.Create(Self);
  ClaimDeclarationDeclarationSignedDate := TDateTimeField.Create(Self);
  ClaimDeclarationDeclarationSignedByUser := TIntegerField.Create(Self);
  ClaimDeclarationDeclarationSignedByName := TStringField.Create(Self);
  ClaimDeclarationDeclarationSigningChannel := TStringField.Create(Self);
  ClaimDeclarationDeclarationStatus := TStringField.Create(Self);
  ClaimDeclarationDeclarationRevokedDate := TDateTimeField.Create(Self);
  ClaimDeclarationSignedDeclarationText := TStringField.Create(Self);
  LoginPassword := TEdit.Create('LoginPassword');
  ConfirmSignDeclarationButton := TButton.Create('ConfirmSignDeclarationButton');
  CancelSignDeclarationButton := TButton.Create('CancelSignDeclarationButton');
  PrepareClaimTimer := TTimer.Create(Self);

  JobsPlacedTable.BeforeLoadDFMValues;
  CancelButton.BeforeLoadDFMValues;
  PlaceJobButton.BeforeLoadDFMValues;
  OutputOption.BeforeLoadDFMValues;
  JobVisibility.BeforeLoadDFMValues;
  WaitMessage.BeforeLoadDFMValues;
  JobRunType.BeforeLoadDFMValues;
  AgreeCheckBox.BeforeLoadDFMValues;
  AuthorisedOfficial.BeforeLoadDFMValues;
  ErrorHandling.BeforeLoadDFMValues;
  HMRCPassword.BeforeLoadDFMValues;
  UserClaimRef.BeforeLoadDFMValues;
  PrepareClaimDataXXX.BeforeLoadDFMValues;
  ConfirmClaimCheckBox.BeforeLoadDFMValues;
  OldestDateParameter.BeforeLoadDFMValues;
  NewestDateParameter.BeforeLoadDFMValues;
  ImportFiles.BeforeLoadDFMValues;
  MaximumGiftAidAmountForClaim.BeforeLoadDFMValues;
  PrepareWaitMessage.BeforeLoadDFMValues;
  CancelPrepareClaimButton.BeforeLoadDFMValues;
  PrepareClaimButton.BeforeLoadDFMValues;
  DownloadDonationsButton.BeforeLoadDFMValues;
  ViewAdjustmentsButton.BeforeLoadDFMValues;
  DeclarationTextMemo.BeforeLoadDFMValues;
  PrepareClaimData.BeforeLoadDFMValues;
  AcknowledgePartialClaim.BeforeLoadDFMValues;
  JobsPlaced.BeforeLoadDFMValues;
  JobsPlacedDateAdded.BeforeLoadDFMValues;
  JobsPlacedAddedBy.BeforeLoadDFMValues;
  JobsPlacedLastUpdatedBy.BeforeLoadDFMValues;
  JobsPlacedJobCategory.BeforeLoadDFMValues;
  JobsPlacedLastPolled.BeforeLoadDFMValues;
  JobsPlacedPollInterval.BeforeLoadDFMValues;
  JobsPlacedPollCount.BeforeLoadDFMValues;
  CloseTimer.BeforeLoadDFMValues;
  AuthOfficials.BeforeLoadDFMValues;
  AuthOfficialsId.BeforeLoadDFMValues;
  AuthOfficialsFirstName.BeforeLoadDFMValues;
  AuthOfficialsLastName.BeforeLoadDFMValues;
  ConfigDataset.BeforeLoadDFMValues;
  ConfigDatasetId.BeforeLoadDFMValues;
  ConfigDatasetHMRCOfficial.BeforeLoadDFMValues;
  ConfigDatasetCharityRef.BeforeLoadDFMValues;
  ConfigDatasetCharityType.BeforeLoadDFMValues;
  ConfigDatasetGatewayId.BeforeLoadDFMValues;
  ConfigDatasetGatewayPassword.BeforeLoadDFMValues;
  ConfigDatasetRegulator.BeforeLoadDFMValues;
  ConfigDatasetRegulatorNumber.BeforeLoadDFMValues;
  ConfigDatasetEndOfYear.BeforeLoadDFMValues;
  ConfigDatasetOrganisationType.BeforeLoadDFMValues;
  ConfigDatasetOrganisationName.BeforeLoadDFMValues;
  ConfigDatasetSubmissionMethod.BeforeLoadDFMValues;
  GAUsers.BeforeLoadDFMValues;
  InitialCheck.BeforeLoadDFMValues;
  DisplayClaimDeclaration.BeforeLoadDFMValues;
  ClaimDeclaration.BeforeLoadDFMValues;
  ClaimDeclarationId.BeforeLoadDFMValues;
  ClaimDeclarationDateAdded.BeforeLoadDFMValues;
  ClaimDeclarationAddedBy.BeforeLoadDFMValues;
  ClaimDeclarationLastUpdatedBy.BeforeLoadDFMValues;
  ClaimDeclarationLastUpdated.BeforeLoadDFMValues;
  ClaimDeclarationClaimId.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationVersion.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationHash.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationIssueDate.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationExpiryDate.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationSignedDate.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationSignedByUser.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationSignedByName.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationSigningChannel.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationStatus.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationRevokedDate.BeforeLoadDFMValues;
  ClaimDeclarationSignedDeclarationText.BeforeLoadDFMValues;
  LoginPassword.BeforeLoadDFMValues;
  ConfirmSignDeclarationButton.BeforeLoadDFMValues;
  CancelSignDeclarationButton.BeforeLoadDFMValues;
  PrepareClaimTimer.BeforeLoadDFMValues;
  try
    JobsPlacedTable.Top := 8;
    CancelButton.Left := 414;
    SetEvent(PlaceJobButton, Self, 'OnClick', 'PlaceSubmissionJobButtonClick');
    OutputOption.Top := 263;
    JobVisibility.Visible := False;
    WaitMessage.Left := 104;
    WaitMessage.Top := 425;
    JobRunType.Visible := False;
    AgreeCheckBox.SetParentComponent(Self);
    AgreeCheckBox.Name := 'AgreeCheckBox';
    AgreeCheckBox.Left := 64;
    AgreeCheckBox.Top := 350;
    AgreeCheckBox.Width := 113;
    AgreeCheckBox.Height := 22;
    AgreeCheckBox.Caption := 'I Agree';
    AgreeCheckBox.ChildOrder := 10;
    AgreeCheckBox.ElementClassName := 'custom-control custom-checkbox';
    AgreeCheckBox.ElementButtonClassName := 'from-control-input';
    AgreeCheckBox.ElementLabelClassName := 'form-control-label';
    AgreeCheckBox.ElementFont := efCSS;
    AgreeCheckBox.ElementPosition := epIgnore;
    AgreeCheckBox.Enabled := False;
    AgreeCheckBox.HeightStyle := ssAuto;
    AgreeCheckBox.HeightPercent := 100.000000000000000000;
    AgreeCheckBox.WidthStyle := ssAuto;
    AgreeCheckBox.WidthPercent := 100.000000000000000000;
    SetEvent(AgreeCheckBox, Self, 'OnClick', 'AgreeCheckBoxClick');
    AuthorisedOfficial.SetParentComponent(Self);
    AuthorisedOfficial.Name := 'AuthorisedOfficial';
    AuthorisedOfficial.Left := 352;
    AuthorisedOfficial.Top := 378;
    AuthorisedOfficial.Width := 249;
    AuthorisedOfficial.Height := 22;
    AuthorisedOfficial.ElementClassName := 'form-select form-control';
    AuthorisedOfficial.ElementFont := efCSS;
    AuthorisedOfficial.ElementPosition := epIgnore;
    AuthorisedOfficial.HeightStyle := ssAuto;
    AuthorisedOfficial.HeightPercent := 100.000000000000000000;
    AuthorisedOfficial.WidthStyle := ssAuto;
    AuthorisedOfficial.WidthPercent := 100.000000000000000000;
    AuthorisedOfficial.ItemIndex := -1;
    SetEvent(AuthorisedOfficial, Self, 'OnChange', 'AuthorisedOfficialChange');
    ErrorHandling.SetParentComponent(Self);
    ErrorHandling.Name := 'ErrorHandling';
    ErrorHandling.Left := 63;
    ErrorHandling.Top := 380;
    ErrorHandling.Width := 249;
    ErrorHandling.Height := 22;
    ErrorHandling.ElementClassName := 'form-select';
    ErrorHandling.ElementFont := efCSS;
    ErrorHandling.HeightPercent := 100.000000000000000000;
    ErrorHandling.WidthPercent := 100.000000000000000000;
    ErrorHandling.ItemIndex := -1;
    HMRCPassword.SetParentComponent(Self);
    HMRCPassword.Name := 'HMRCPassword';
    HMRCPassword.Left := 352;
    HMRCPassword.Top := 350;
    HMRCPassword.Width := 249;
    HMRCPassword.Height := 22;
    HMRCPassword.AutoCompletion := acNone;
    HMRCPassword.AutoSelect := False;
    HMRCPassword.ChildOrder := 13;
    HMRCPassword.ElementClassName := 'form-control';
    HMRCPassword.ElementPosition := epIgnore;
    HMRCPassword.HeightStyle := ssAuto;
    HMRCPassword.HeightPercent := 100.000000000000000000;
    HMRCPassword.PasswordChar := '*';
    HMRCPassword.WidthStyle := ssAuto;
    HMRCPassword.WidthPercent := 100.000000000000000000;
    SetEvent(HMRCPassword, Self, 'OnChange', 'HMRCPasswordChange');
    SetEvent(HMRCPassword, Self, 'OnExit', 'HMRCPasswordExit');
    UserClaimRef.SetParentComponent(Self);
    UserClaimRef.Name := 'UserClaimRef';
    UserClaimRef.Left := 134;
    UserClaimRef.Top := 408;
    UserClaimRef.Width := 121;
    UserClaimRef.Height := 22;
    UserClaimRef.AutoSelect := False;
    UserClaimRef.CharCase := wecUpperCase;
    UserClaimRef.ChildOrder := 13;
    UserClaimRef.ElementPosition := epIgnore;
    UserClaimRef.HeightStyle := ssAuto;
    UserClaimRef.HeightPercent := 100.000000000000000000;
    UserClaimRef.MaxLength := 20;
    UserClaimRef.WidthStyle := ssAuto;
    UserClaimRef.WidthPercent := 100.000000000000000000;
    SetEvent(UserClaimRef, Self, 'OnChange', 'UserClaimRefChange');
    SetEvent(UserClaimRef, Self, 'OnExit', 'UserClaimRefExit');
    PrepareClaimDataXXX.SetParentComponent(Self);
    PrepareClaimDataXXX.Name := 'PrepareClaimDataXXX';
    PrepareClaimDataXXX.Left := 64;
    PrepareClaimDataXXX.Top := 216;
    PrepareClaimDataXXX.Width := 488;
    PrepareClaimDataXXX.Height := 41;
    PrepareClaimDataXXX.HeightStyle := ssAuto;
    PrepareClaimDataXXX.WidthStyle := ssAuto;
    PrepareClaimDataXXX.BorderColor := clSilver;
    PrepareClaimDataXXX.ChildOrder := 15;
    PrepareClaimDataXXX.ElementFont := efCSS;
    PrepareClaimDataXXX.ElementHeaderClassName := 'thead-light';
    PrepareClaimDataXXX.ElementPosition := epIgnore;
    PrepareClaimDataXXX.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    PrepareClaimDataXXX.Header.Caption := 'WOOOOOOOF';
    PrepareClaimDataXXX.Options.CellBorders := True;
    PrepareClaimDataXXX.Options.ResizeColumns := True;
    PrepareClaimDataXXX.Visible := False;
    PrepareClaimDataXXX.ColCount := 2;
    PrepareClaimDataXXX.RowCount := 2;
    ConfirmClaimCheckBox.SetParentComponent(Self);
    ConfirmClaimCheckBox.Name := 'ConfirmClaimCheckBox';
    ConfirmClaimCheckBox.Left := 64;
    ConfirmClaimCheckBox.Top := 183;
    ConfirmClaimCheckBox.Width := 145;
    ConfirmClaimCheckBox.Height := 22;
    ConfirmClaimCheckBox.Caption := 'Confirm Claim';
    ConfirmClaimCheckBox.ChildOrder := 16;
    ConfirmClaimCheckBox.ElementClassName := 'form-check-input';
    ConfirmClaimCheckBox.ElementPosition := epIgnore;
    ConfirmClaimCheckBox.Enabled := False;
    ConfirmClaimCheckBox.Font.Charset := DEFAULT_CHARSET;
    ConfirmClaimCheckBox.Font.Color := clWindowText;
    ConfirmClaimCheckBox.Font.Height := -18;
    ConfirmClaimCheckBox.Font.Name := 'Segoe UI';
    ConfirmClaimCheckBox.Font.Style := [];
    ConfirmClaimCheckBox.HeightStyle := ssAuto;
    ConfirmClaimCheckBox.HeightPercent := 100.000000000000000000;
    ConfirmClaimCheckBox.ParentFont := False;
    ConfirmClaimCheckBox.WidthStyle := ssAuto;
    ConfirmClaimCheckBox.WidthPercent := 100.000000000000000000;
    SetEvent(ConfirmClaimCheckBox, Self, 'OnClick', 'ConfirmClaimCheckBoxClick');
    OldestDateParameter.SetParentComponent(Self);
    OldestDateParameter.Name := 'OldestDateParameter';
    OldestDateParameter.Left := 248;
    OldestDateParameter.Top := 167;
    OldestDateParameter.Width := 160;
    OldestDateParameter.Height := 22;
    OldestDateParameter.ElementClassName := 'form-control';
    OldestDateParameter.HeightStyle := ssAuto;
    OldestDateParameter.WidthStyle := ssAuto;
    OldestDateParameter.BorderStyle := bsSingle;
    OldestDateParameter.ChildOrder := 18;
    OldestDateParameter.Color := clWhite;
    OldestDateParameter.Date := 46090.416217013890000000;
    OldestDateParameter.ElementPosition := epIgnore;
    OldestDateParameter.Role := '';
    OldestDateParameter.Text := '';
    SetEvent(OldestDateParameter, Self, 'OnChange', 'ParameterChange');
    NewestDateParameter.SetParentComponent(Self);
    NewestDateParameter.Name := 'NewestDateParameter';
    NewestDateParameter.Left := 248;
    NewestDateParameter.Top := 195;
    NewestDateParameter.Width := 160;
    NewestDateParameter.Height := 22;
    NewestDateParameter.ElementClassName := 'form-control';
    NewestDateParameter.HeightStyle := ssAuto;
    NewestDateParameter.WidthStyle := ssAuto;
    NewestDateParameter.BorderStyle := bsSingle;
    NewestDateParameter.ChildOrder := 18;
    NewestDateParameter.Color := clWhite;
    NewestDateParameter.Date := 46090.416217013890000000;
    NewestDateParameter.ElementPosition := epIgnore;
    NewestDateParameter.Role := '';
    NewestDateParameter.Text := '';
    SetEvent(NewestDateParameter, Self, 'OnChange', 'ParameterChange');
    ImportFiles.SetParentComponent(Self);
    ImportFiles.Name := 'ImportFiles';
    ImportFiles.Left := 248;
    ImportFiles.Top := 128;
    ImportFiles.Width := 160;
    ImportFiles.Height := 22;
    ImportFiles.ElementClassName := 'form-select';
    ImportFiles.ElementPosition := epIgnore;
    ImportFiles.HeightStyle := ssAuto;
    ImportFiles.HeightPercent := 100.000000000000000000;
    ImportFiles.WidthStyle := ssAuto;
    ImportFiles.WidthPercent := 100.000000000000000000;
    SetEvent(ImportFiles, Self, 'OnChange', 'ParameterChange');
    ImportFiles.ItemIndex := -1;
    MaximumGiftAidAmountForClaim.SetParentComponent(Self);
    MaximumGiftAidAmountForClaim.Name := 'MaximumGiftAidAmountForClaim';
    MaximumGiftAidAmountForClaim.Left := 248;
    MaximumGiftAidAmountForClaim.Top := 223;
    MaximumGiftAidAmountForClaim.Width := 160;
    MaximumGiftAidAmountForClaim.Height := 22;
    MaximumGiftAidAmountForClaim.ChildOrder := 19;
    MaximumGiftAidAmountForClaim.ElementClassName := 'form-control';
    MaximumGiftAidAmountForClaim.ElementPosition := epIgnore;
    MaximumGiftAidAmountForClaim.HeightStyle := ssAuto;
    MaximumGiftAidAmountForClaim.HeightPercent := 100.000000000000000000;
    MaximumGiftAidAmountForClaim.WidthStyle := ssAuto;
    MaximumGiftAidAmountForClaim.WidthPercent := 100.000000000000000000;
    SetEvent(MaximumGiftAidAmountForClaim, Self, 'OnChange', 'MaximumGiftAidAmountForClaimChange');
    SetEvent(MaximumGiftAidAmountForClaim, Self, 'OnExit', 'MaximumGiftAidAmountForClaimExit');
    PrepareWaitMessage.SetParentComponent(Self);
    PrepareWaitMessage.Name := 'PrepareWaitMessage';
    PrepareWaitMessage.Left := 8;
    PrepareWaitMessage.Top := 288;
    PrepareWaitMessage.Width := 24;
    PrepareWaitMessage.Height := 24;
    PrepareWaitMessage.Opacity := 0.200000000000000000;
    PrepareWaitMessage.Picture.LoadFromFile('GiftAidClaimForm.PrepareWaitMessage.Picture.gif');
    CancelPrepareClaimButton.SetParentComponent(Self);
    CancelPrepareClaimButton.Name := 'CancelPrepareClaimButton';
    CancelPrepareClaimButton.Left := 424;
    CancelPrepareClaimButton.Top := 132;
    CancelPrepareClaimButton.Width := 96;
    CancelPrepareClaimButton.Height := 25;
    CancelPrepareClaimButton.Caption := 'Cancel Prepare Claim';
    CancelPrepareClaimButton.ChildOrder := 21;
    CancelPrepareClaimButton.ElementClassName := 'btn btn-secondary';
    CancelPrepareClaimButton.ElementPosition := epIgnore;
    CancelPrepareClaimButton.HeightStyle := ssAuto;
    CancelPrepareClaimButton.HeightPercent := 100.000000000000000000;
    CancelPrepareClaimButton.WidthStyle := ssAuto;
    CancelPrepareClaimButton.WidthPercent := 100.000000000000000000;
    SetEvent(CancelPrepareClaimButton, Self, 'OnClick', 'CancelPrepareClaimButtonClick');
    PrepareClaimButton.SetParentComponent(Self);
    PrepareClaimButton.Name := 'PrepareClaimButton';
    PrepareClaimButton.Left := 64;
    PrepareClaimButton.Top := 136;
    PrepareClaimButton.Width := 178;
    PrepareClaimButton.Height := 25;
    PrepareClaimButton.Caption := 'Prepare Claim';
    PrepareClaimButton.ChildOrder := 22;
    PrepareClaimButton.ElementClassName := 'btn btn-secondary';
    PrepareClaimButton.ElementPosition := epIgnore;
    PrepareClaimButton.HeightStyle := ssAuto;
    PrepareClaimButton.HeightPercent := 100.000000000000000000;
    PrepareClaimButton.WidthStyle := ssAuto;
    PrepareClaimButton.WidthPercent := 100.000000000000000000;
    SetEvent(PrepareClaimButton, Self, 'OnClick', 'PrepareClaimButtonClick');
    DownloadDonationsButton.SetParentComponent(Self);
    DownloadDonationsButton.Name := 'DownloadDonationsButton';
    DownloadDonationsButton.Left := 64;
    DownloadDonationsButton.Top := 168;
    DownloadDonationsButton.Width := 178;
    DownloadDonationsButton.Height := 25;
    DownloadDonationsButton.Caption := 'Download Donations';
    DownloadDonationsButton.ElementClassName := 'btn btn-outline-primary';
    DownloadDonationsButton.ElementPosition := epIgnore;
    DownloadDonationsButton.HeightStyle := ssAuto;
    DownloadDonationsButton.HeightPercent := 100.000000000000000000;
    DownloadDonationsButton.Visible := False;
    DownloadDonationsButton.WidthStyle := ssAuto;
    DownloadDonationsButton.WidthPercent := 100.000000000000000000;
    SetEvent(DownloadDonationsButton, Self, 'OnClick', 'DownloadDonationsButtonClick');
    ViewAdjustmentsButton.SetParentComponent(Self);
    ViewAdjustmentsButton.Name := 'ViewAdjustmentsButton';
    ViewAdjustmentsButton.Left := 64;
    ViewAdjustmentsButton.Top := 200;
    ViewAdjustmentsButton.Width := 178;
    ViewAdjustmentsButton.Height := 25;
    ViewAdjustmentsButton.Caption := 'View Adjustments';
    ViewAdjustmentsButton.ElementClassName := 'btn btn-outline-primary';
    ViewAdjustmentsButton.ElementPosition := epIgnore;
    ViewAdjustmentsButton.HeightStyle := ssAuto;
    ViewAdjustmentsButton.HeightPercent := 100.000000000000000000;
    ViewAdjustmentsButton.Visible := False;
    ViewAdjustmentsButton.WidthStyle := ssAuto;
    ViewAdjustmentsButton.WidthPercent := 100.000000000000000000;
    SetEvent(ViewAdjustmentsButton, Self, 'OnClick', 'ViewAdjustmentsButtonClick');
    DeclarationTextMemo.SetParentComponent(Self);
    DeclarationTextMemo.Name := 'DeclarationTextMemo';
    DeclarationTextMemo.Left := 400;
    DeclarationTextMemo.Top := 93;
    DeclarationTextMemo.Width := 185;
    DeclarationTextMemo.Height := 89;
    DeclarationTextMemo.ElementPosition := epIgnore;
    DeclarationTextMemo.HeightStyle := ssAuto;
    DeclarationTextMemo.HeightPercent := 100.000000000000000000;
    DeclarationTextMemo.Lines.BeginUpdate;
    try
      DeclarationTextMemo.Lines.Clear;
      DeclarationTextMemo.Lines.Add('Loading declaration...');
    finally
      DeclarationTextMemo.Lines.EndUpdate;
    end;
    DeclarationTextMemo.ReadOnly := True;
    DeclarationTextMemo.SelLength := 0;
    DeclarationTextMemo.SelStart := 0;
    DeclarationTextMemo.WidthStyle := ssAuto;
    DeclarationTextMemo.WidthPercent := 100.000000000000000000;
    PrepareClaimData.SetParentComponent(Self);
    PrepareClaimData.Name := 'PrepareClaimData';
    PrepareClaimData.Left := 38;
    PrepareClaimData.Top := 249;
    PrepareClaimData.Width := 561;
    PrepareClaimData.Height := 123;
    PrepareClaimData.HeightStyle := ssAuto;
    PrepareClaimData.WidthStyle := ssAuto;
    PrepareClaimData.BorderColor := clSilver;
    PrepareClaimData.ChildOrder := 13;
    PrepareClaimData.ElementFont := efCSS;
    PrepareClaimData.ElementHeaderClassName := 'thead-light';
    PrepareClaimData.ElementPosition := epIgnore;
    PrepareClaimData.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    PrepareClaimData.ColCount := 3;
    PrepareClaimData.RowCount := 2;
    AcknowledgePartialClaim.SetParentComponent(Self);
    AcknowledgePartialClaim.Name := 'AcknowledgePartialClaim';
    AcknowledgePartialClaim.Left := 64;
    AcknowledgePartialClaim.Top := 420;
    AcknowledgePartialClaim.Width := 280;
    AcknowledgePartialClaim.Height := 22;
    AcknowledgePartialClaim.Caption := 'Acknowledge partial claim';
    AcknowledgePartialClaim.ChildOrder := 24;
    AcknowledgePartialClaim.ElementClassName := 'form-check-input';
    AcknowledgePartialClaim.ElementFont := efCSS;
    AcknowledgePartialClaim.ElementPosition := epIgnore;
    AcknowledgePartialClaim.HeightStyle := ssAuto;
    AcknowledgePartialClaim.HeightPercent := 100.000000000000000000;
    AcknowledgePartialClaim.WidthStyle := ssAuto;
    AcknowledgePartialClaim.WidthPercent := 100.000000000000000000;
    SetEvent(AcknowledgePartialClaim, Self, 'OnClick', 'AcknowledgePartialClaimClick');
    JobsPlacedDateAdded.SetParentComponent(JobsPlaced);
    JobsPlacedDateAdded.Name := 'JobsPlacedDateAdded';
    JobsPlacedDateAdded.FieldName := 'DateAdded';
    JobsPlacedAddedBy.SetParentComponent(JobsPlaced);
    JobsPlacedAddedBy.Name := 'JobsPlacedAddedBy';
    JobsPlacedAddedBy.FieldName := 'AddedBy';
    JobsPlacedLastUpdatedBy.SetParentComponent(JobsPlaced);
    JobsPlacedLastUpdatedBy.Name := 'JobsPlacedLastUpdatedBy';
    JobsPlacedLastUpdatedBy.FieldName := 'LastUpdatedBy';
    JobsPlacedJobCategory.SetParentComponent(JobsPlaced);
    JobsPlacedJobCategory.Name := 'JobsPlacedJobCategory';
    JobsPlacedJobCategory.FieldName := 'JobCategory';
    JobsPlacedJobCategory.Size := 8;
    JobsPlacedLastPolled.SetParentComponent(JobsPlaced);
    JobsPlacedLastPolled.Name := 'JobsPlacedLastPolled';
    JobsPlacedLastPolled.FieldName := 'LastPolled';
    JobsPlacedPollInterval.SetParentComponent(JobsPlaced);
    JobsPlacedPollInterval.Name := 'JobsPlacedPollInterval';
    JobsPlacedPollInterval.FieldName := 'PollInterval';
    JobsPlacedPollCount.SetParentComponent(JobsPlaced);
    JobsPlacedPollCount.Name := 'JobsPlacedPollCount';
    JobsPlacedPollCount.FieldName := 'PollCount';
    CloseTimer.Left := 32;
    CloseTimer.Top := 424;
    AuthOfficials.SetParentComponent(Self);
    AuthOfficials.Name := 'AuthOfficials';
    AuthOfficials.AfterOpen := AuthOfficialsAfterOpen;
    AuthOfficials.EntitySetName := 'User';
    AuthOfficials.Connection := MainData.DataConnection;
    AuthOfficials.Left := 456;
    AuthOfficials.Top := 64;
    AuthOfficialsId.SetParentComponent(AuthOfficials);
    AuthOfficialsId.Name := 'AuthOfficialsId';
    AuthOfficialsId.FieldName := 'Id';
    AuthOfficialsFirstName.SetParentComponent(AuthOfficials);
    AuthOfficialsFirstName.Name := 'AuthOfficialsFirstName';
    AuthOfficialsFirstName.FieldName := 'FirstName';
    AuthOfficialsFirstName.Size := 50;
    AuthOfficialsLastName.SetParentComponent(AuthOfficials);
    AuthOfficialsLastName.Name := 'AuthOfficialsLastName';
    AuthOfficialsLastName.FieldName := 'LastName';
    AuthOfficialsLastName.Size := 50;
    ConfigDataset.SetParentComponent(Self);
    ConfigDataset.Name := 'ConfigDataset';
    ConfigDataset.AfterOpen := ConfigDatasetAfterOpen;
    ConfigDataset.EntitySetName := 'GiftAidParams';
    ConfigDataset.Connection := MainData.DataConnection;
    ConfigDataset.Left := 544;
    ConfigDataset.Top := 64;
    ConfigDatasetId.SetParentComponent(ConfigDataset);
    ConfigDatasetId.Name := 'ConfigDatasetId';
    ConfigDatasetId.FieldName := 'Id';
    ConfigDatasetHMRCOfficial.SetParentComponent(ConfigDataset);
    ConfigDatasetHMRCOfficial.Name := 'ConfigDatasetHMRCOfficial';
    ConfigDatasetHMRCOfficial.FieldName := 'HMRCOfficial';
    ConfigDatasetCharityRef.SetParentComponent(ConfigDataset);
    ConfigDatasetCharityRef.Name := 'ConfigDatasetCharityRef';
    ConfigDatasetCharityRef.FieldName := 'CharityRef';
    ConfigDatasetCharityRef.Size := 50;
    ConfigDatasetCharityType.SetParentComponent(ConfigDataset);
    ConfigDatasetCharityType.Name := 'ConfigDatasetCharityType';
    ConfigDatasetCharityType.FieldName := 'CharityType';
    ConfigDatasetCharityType.Size := 15;
    ConfigDatasetGatewayId.SetParentComponent(ConfigDataset);
    ConfigDatasetGatewayId.Name := 'ConfigDatasetGatewayId';
    ConfigDatasetGatewayId.FieldName := 'GatewayId';
    ConfigDatasetGatewayId.Size := 50;
    ConfigDatasetGatewayPassword.SetParentComponent(ConfigDataset);
    ConfigDatasetGatewayPassword.Name := 'ConfigDatasetGatewayPassword';
    ConfigDatasetGatewayPassword.FieldName := 'GatewayPassword';
    ConfigDatasetGatewayPassword.Size := 64;
    ConfigDatasetRegulator.SetParentComponent(ConfigDataset);
    ConfigDatasetRegulator.Name := 'ConfigDatasetRegulator';
    ConfigDatasetRegulator.FieldName := 'Regulator';
    ConfigDatasetRegulator.Size := 5;
    ConfigDatasetRegulatorNumber.SetParentComponent(ConfigDataset);
    ConfigDatasetRegulatorNumber.Name := 'ConfigDatasetRegulatorNumber';
    ConfigDatasetRegulatorNumber.FieldName := 'RegulatorNumber';
    ConfigDatasetRegulatorNumber.Size := 50;
    ConfigDatasetEndOfYear.SetParentComponent(ConfigDataset);
    ConfigDatasetEndOfYear.Name := 'ConfigDatasetEndOfYear';
    ConfigDatasetEndOfYear.FieldName := 'EndOfYear';
    ConfigDatasetEndOfYear.Size := 5;
    ConfigDatasetOrganisationType.SetParentComponent(ConfigDataset);
    ConfigDatasetOrganisationType.Name := 'ConfigDatasetOrganisationType';
    ConfigDatasetOrganisationType.FieldName := 'OrganisationType';
    ConfigDatasetOrganisationType.Size := 16;
    ConfigDatasetOrganisationName.SetParentComponent(ConfigDataset);
    ConfigDatasetOrganisationName.Name := 'ConfigDatasetOrganisationName';
    ConfigDatasetOrganisationName.FieldName := 'OrganisationName';
    ConfigDatasetOrganisationName.Size := 250;
    ConfigDatasetSubmissionMethod.SetParentComponent(ConfigDataset);
    ConfigDatasetSubmissionMethod.Name := 'ConfigDatasetSubmissionMethod';
    ConfigDatasetSubmissionMethod.FieldName := 'SubmissionMethod';
    ConfigDatasetSubmissionMethod.Size := 4;
    GAUsers.SetParentComponent(Self);
    GAUsers.Name := 'GAUsers';
    GAUsers.Left := 8;
    GAUsers.Top := 16;
    InitialCheck.SetParentComponent(Self);
    InitialCheck.Name := 'InitialCheck';
    InitialCheck.Enabled := False;
    SetEvent(InitialCheck, Self, 'OnTimer', 'InitialCheckTimer');
    InitialCheck.Left := 576;
    InitialCheck.Top := 136;
    DisplayClaimDeclaration.SetParentComponent(Self);
    DisplayClaimDeclaration.Name := 'DisplayClaimDeclaration';
    DisplayClaimDeclaration.Enabled := False;
    SetEvent(DisplayClaimDeclaration, Self, 'OnTimer', 'DisplayClaimDeclarationTimer');
    DisplayClaimDeclaration.Left := 576;
    DisplayClaimDeclaration.Top := 264;
    ClaimDeclaration.SetParentComponent(Self);
    ClaimDeclaration.Name := 'ClaimDeclaration';
    ClaimDeclaration.AfterPost := ClaimDeclarationAfterPost;
    ClaimDeclaration.EntitySetName := 'ClaimDeclaration';
    ClaimDeclaration.Connection := MainData.DataConnection;
    ClaimDeclaration.Left := 472;
    ClaimDeclaration.Top := 136;
    ClaimDeclarationId.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationId.Name := 'ClaimDeclarationId';
    ClaimDeclarationId.FieldName := 'Id';
    ClaimDeclarationDateAdded.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDateAdded.Name := 'ClaimDeclarationDateAdded';
    ClaimDeclarationDateAdded.FieldName := 'DateAdded';
    ClaimDeclarationAddedBy.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationAddedBy.Name := 'ClaimDeclarationAddedBy';
    ClaimDeclarationAddedBy.FieldName := 'AddedBy';
    ClaimDeclarationLastUpdatedBy.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationLastUpdatedBy.Name := 'ClaimDeclarationLastUpdatedBy';
    ClaimDeclarationLastUpdatedBy.FieldName := 'LastUpdatedBy';
    ClaimDeclarationLastUpdated.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationLastUpdated.Name := 'ClaimDeclarationLastUpdated';
    ClaimDeclarationLastUpdated.FieldName := 'LastUpdated';
    ClaimDeclarationClaimId.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationClaimId.Name := 'ClaimDeclarationClaimId';
    ClaimDeclarationClaimId.FieldName := 'ClaimId';
    ClaimDeclarationDeclarationVersion.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationVersion.Name := 'ClaimDeclarationDeclarationVersion';
    ClaimDeclarationDeclarationVersion.FieldName := 'DeclarationVersion';
    ClaimDeclarationDeclarationHash.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationHash.Name := 'ClaimDeclarationDeclarationHash';
    ClaimDeclarationDeclarationHash.FieldName := 'DeclarationHash';
    ClaimDeclarationDeclarationHash.Size := 64;
    ClaimDeclarationDeclarationIssueDate.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationIssueDate.Name := 'ClaimDeclarationDeclarationIssueDate';
    ClaimDeclarationDeclarationIssueDate.FieldName := 'DeclarationIssueDate';
    ClaimDeclarationDeclarationExpiryDate.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationExpiryDate.Name := 'ClaimDeclarationDeclarationExpiryDate';
    ClaimDeclarationDeclarationExpiryDate.FieldName := 'DeclarationExpiryDate';
    ClaimDeclarationDeclarationSignedDate.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationSignedDate.Name := 'ClaimDeclarationDeclarationSignedDate';
    ClaimDeclarationDeclarationSignedDate.FieldName := 'DeclarationSignedDate';
    ClaimDeclarationDeclarationSignedByUser.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationSignedByUser.Name := 'ClaimDeclarationDeclarationSignedByUser';
    ClaimDeclarationDeclarationSignedByUser.FieldName := 'DeclarationSignedByUser';
    ClaimDeclarationDeclarationSignedByName.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationSignedByName.Name := 'ClaimDeclarationDeclarationSignedByName';
    ClaimDeclarationDeclarationSignedByName.FieldName := 'DeclarationSignedByName';
    ClaimDeclarationDeclarationSignedByName.Size := 100;
    ClaimDeclarationDeclarationSigningChannel.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationSigningChannel.Name := 'ClaimDeclarationDeclarationSigningChannel';
    ClaimDeclarationDeclarationSigningChannel.FieldName := 'DeclarationSigningChannel';
    ClaimDeclarationDeclarationSigningChannel.Size := 10;
    ClaimDeclarationDeclarationStatus.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationStatus.Name := 'ClaimDeclarationDeclarationStatus';
    ClaimDeclarationDeclarationStatus.FieldName := 'DeclarationStatus';
    ClaimDeclarationDeclarationStatus.Size := 10;
    ClaimDeclarationDeclarationRevokedDate.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationRevokedDate.Name := 'ClaimDeclarationDeclarationRevokedDate';
    ClaimDeclarationDeclarationRevokedDate.FieldName := 'DeclarationRevokedDate';
    ClaimDeclarationSignedDeclarationText.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationSignedDeclarationText.Name := 'ClaimDeclarationSignedDeclarationText';
    ClaimDeclarationSignedDeclarationText.FieldName := 'SignedDeclarationText';
    ClaimDeclarationSignedDeclarationText.Size := 2048;
    LoginPassword.SetParentComponent(Self);
    LoginPassword.Name := 'LoginPassword';
    LoginPassword.Left := 352;
    LoginPassword.Top := 320;
    LoginPassword.Width := 249;
    LoginPassword.Height := 22;
    LoginPassword.AutoCompletion := acNone;
    LoginPassword.AutoSelect := False;
    LoginPassword.ChildOrder := 26;
    LoginPassword.ElementClassName := 'form-control';
    LoginPassword.ElementPosition := epIgnore;
    LoginPassword.HeightStyle := ssAuto;
    LoginPassword.HeightPercent := 100.000000000000000000;
    LoginPassword.PasswordChar := '*';
    LoginPassword.WidthStyle := ssAuto;
    LoginPassword.WidthPercent := 100.000000000000000000;
    SetEvent(LoginPassword, Self, 'OnKeyPress', 'LoginPasswordKeyPress');
    ConfirmSignDeclarationButton.SetParentComponent(Self);
    ConfirmSignDeclarationButton.Name := 'ConfirmSignDeclarationButton';
    ConfirmSignDeclarationButton.Left := 64;
    ConfirmSignDeclarationButton.Top := 496;
    ConfirmSignDeclarationButton.Width := 160;
    ConfirmSignDeclarationButton.Height := 31;
    ConfirmSignDeclarationButton.Caption := 'OK';
    ConfirmSignDeclarationButton.ChildOrder := 27;
    ConfirmSignDeclarationButton.ElementClassName := 'btn btn-primary';
    ConfirmSignDeclarationButton.ElementFont := efCSS;
    ConfirmSignDeclarationButton.ElementPosition := epIgnore;
    ConfirmSignDeclarationButton.HeightStyle := ssAuto;
    ConfirmSignDeclarationButton.HeightPercent := 100.000000000000000000;
    ConfirmSignDeclarationButton.WidthStyle := ssAuto;
    ConfirmSignDeclarationButton.WidthPercent := 100.000000000000000000;
    SetEvent(ConfirmSignDeclarationButton, Self, 'OnClick', 'ConfirmSignDeclarationButtonClick');
    CancelSignDeclarationButton.SetParentComponent(Self);
    CancelSignDeclarationButton.Name := 'CancelSignDeclarationButton';
    CancelSignDeclarationButton.Left := 240;
    CancelSignDeclarationButton.Top := 496;
    CancelSignDeclarationButton.Width := 120;
    CancelSignDeclarationButton.Height := 31;
    CancelSignDeclarationButton.Caption := 'Cancel';
    CancelSignDeclarationButton.ChildOrder := 28;
    CancelSignDeclarationButton.ElementClassName := 'btn btn-outline-secondary';
    CancelSignDeclarationButton.ElementFont := efCSS;
    CancelSignDeclarationButton.ElementPosition := epIgnore;
    CancelSignDeclarationButton.HeightStyle := ssAuto;
    CancelSignDeclarationButton.HeightPercent := 100.000000000000000000;
    CancelSignDeclarationButton.WidthStyle := ssAuto;
    CancelSignDeclarationButton.WidthPercent := 100.000000000000000000;
    SetEvent(CancelSignDeclarationButton, Self, 'OnClick', 'CancelSignDeclarationButtonClick');
    PrepareClaimTimer.SetParentComponent(Self);
    PrepareClaimTimer.Name := 'PrepareClaimTimer';
    PrepareClaimTimer.Enabled := False;
    SetEvent(PrepareClaimTimer, Self, 'OnTimer', 'PrepareClaimTimerTimer');
    PrepareClaimTimer.Left := 576;
    PrepareClaimTimer.Top := 416;
  finally
    JobsPlacedTable.AfterLoadDFMValues;
    CancelButton.AfterLoadDFMValues;
    PlaceJobButton.AfterLoadDFMValues;
    OutputOption.AfterLoadDFMValues;
    JobVisibility.AfterLoadDFMValues;
    WaitMessage.AfterLoadDFMValues;
    JobRunType.AfterLoadDFMValues;
    AgreeCheckBox.AfterLoadDFMValues;
    AuthorisedOfficial.AfterLoadDFMValues;
    ErrorHandling.AfterLoadDFMValues;
    HMRCPassword.AfterLoadDFMValues;
    UserClaimRef.AfterLoadDFMValues;
    PrepareClaimDataXXX.AfterLoadDFMValues;
    ConfirmClaimCheckBox.AfterLoadDFMValues;
    OldestDateParameter.AfterLoadDFMValues;
    NewestDateParameter.AfterLoadDFMValues;
    ImportFiles.AfterLoadDFMValues;
    MaximumGiftAidAmountForClaim.AfterLoadDFMValues;
    PrepareWaitMessage.AfterLoadDFMValues;
    CancelPrepareClaimButton.AfterLoadDFMValues;
    PrepareClaimButton.AfterLoadDFMValues;
    DownloadDonationsButton.AfterLoadDFMValues;
    ViewAdjustmentsButton.AfterLoadDFMValues;
    DeclarationTextMemo.AfterLoadDFMValues;
    PrepareClaimData.AfterLoadDFMValues;
    AcknowledgePartialClaim.AfterLoadDFMValues;
    JobsPlaced.AfterLoadDFMValues;
    JobsPlacedDateAdded.AfterLoadDFMValues;
    JobsPlacedAddedBy.AfterLoadDFMValues;
    JobsPlacedLastUpdatedBy.AfterLoadDFMValues;
    JobsPlacedJobCategory.AfterLoadDFMValues;
    JobsPlacedLastPolled.AfterLoadDFMValues;
    JobsPlacedPollInterval.AfterLoadDFMValues;
    JobsPlacedPollCount.AfterLoadDFMValues;
    CloseTimer.AfterLoadDFMValues;
    AuthOfficials.AfterLoadDFMValues;
    AuthOfficialsId.AfterLoadDFMValues;
    AuthOfficialsFirstName.AfterLoadDFMValues;
    AuthOfficialsLastName.AfterLoadDFMValues;
    ConfigDataset.AfterLoadDFMValues;
    ConfigDatasetId.AfterLoadDFMValues;
    ConfigDatasetHMRCOfficial.AfterLoadDFMValues;
    ConfigDatasetCharityRef.AfterLoadDFMValues;
    ConfigDatasetCharityType.AfterLoadDFMValues;
    ConfigDatasetGatewayId.AfterLoadDFMValues;
    ConfigDatasetGatewayPassword.AfterLoadDFMValues;
    ConfigDatasetRegulator.AfterLoadDFMValues;
    ConfigDatasetRegulatorNumber.AfterLoadDFMValues;
    ConfigDatasetEndOfYear.AfterLoadDFMValues;
    ConfigDatasetOrganisationType.AfterLoadDFMValues;
    ConfigDatasetOrganisationName.AfterLoadDFMValues;
    ConfigDatasetSubmissionMethod.AfterLoadDFMValues;
    GAUsers.AfterLoadDFMValues;
    InitialCheck.AfterLoadDFMValues;
    DisplayClaimDeclaration.AfterLoadDFMValues;
    ClaimDeclaration.AfterLoadDFMValues;
    ClaimDeclarationId.AfterLoadDFMValues;
    ClaimDeclarationDateAdded.AfterLoadDFMValues;
    ClaimDeclarationAddedBy.AfterLoadDFMValues;
    ClaimDeclarationLastUpdatedBy.AfterLoadDFMValues;
    ClaimDeclarationLastUpdated.AfterLoadDFMValues;
    ClaimDeclarationClaimId.AfterLoadDFMValues;
    ClaimDeclarationDeclarationVersion.AfterLoadDFMValues;
    ClaimDeclarationDeclarationHash.AfterLoadDFMValues;
    ClaimDeclarationDeclarationIssueDate.AfterLoadDFMValues;
    ClaimDeclarationDeclarationExpiryDate.AfterLoadDFMValues;
    ClaimDeclarationDeclarationSignedDate.AfterLoadDFMValues;
    ClaimDeclarationDeclarationSignedByUser.AfterLoadDFMValues;
    ClaimDeclarationDeclarationSignedByName.AfterLoadDFMValues;
    ClaimDeclarationDeclarationSigningChannel.AfterLoadDFMValues;
    ClaimDeclarationDeclarationStatus.AfterLoadDFMValues;
    ClaimDeclarationDeclarationRevokedDate.AfterLoadDFMValues;
    ClaimDeclarationSignedDeclarationText.AfterLoadDFMValues;
    LoginPassword.AfterLoadDFMValues;
    ConfirmSignDeclarationButton.AfterLoadDFMValues;
    CancelSignDeclarationButton.AfterLoadDFMValues;
    PrepareClaimTimer.AfterLoadDFMValues;
  end;
end;

end.
